export const districts = [
    {
        "id": 1001,
        "name_th": "เขตพระนคร",
        "name_en": "Khet Phra Nakhon",
        "province_id": 10
    },
    {
        "id": 1002,
        "name_th": "เขตดุสิต",
        "name_en": "Khet Dusit",
        "province_id": 10
    },
    {
        "id": 1003,
        "name_th": "เขตหนองจอก",
        "name_en": "Khet Nong Chok",
        "province_id": 10
    },
    {
        "id": 1004,
        "name_th": "เขตบางรัก",
        "name_en": "Khet Bang Rak",
        "province_id": 10
    },
    {
        "id": 1005,
        "name_th": "เขตบางเขน",
        "name_en": "Khet Bang Khen",
        "province_id": 10
    },
    {
        "id": 1006,
        "name_th": "เขตบางกะปิ",
        "name_en": "Khet Bang Kapi",
        "province_id": 10
    },
    {
        "id": 1007,
        "name_th": "เขตปทุมวัน",
        "name_en": "Khet Pathum Wan",
        "province_id": 10
    },
    {
        "id": 1008,
        "name_th": "เขตป้อมปราบศัตรูพ่าย",
        "name_en": "Khet Pom Prap Sattru Phai",
        "province_id": 10
    },
    {
        "id": 1009,
        "name_th": "เขตพระโขนง",
        "name_en": "Khet Phra Khanong",
        "province_id": 10
    },
    {
        "id": 1010,
        "name_th": "เขตมีนบุรี",
        "name_en": "Khet Min Buri",
        "province_id": 10
    },
    {
        "id": 1011,
        "name_th": "เขตลาดกระบัง",
        "name_en": "Khet Lat Krabang",
        "province_id": 10
    },
    {
        "id": 1012,
        "name_th": "เขตยานนาวา",
        "name_en": "Khet Yan Nawa",
        "province_id": 10
    },
    {
        "id": 1013,
        "name_th": "เขตสัมพันธวงศ์",
        "name_en": "Khet Samphanthawong",
        "province_id": 10
    },
    {
        "id": 1014,
        "name_th": "เขตพญาไท",
        "name_en": "Khet Phaya Thai",
        "province_id": 10
    },
    {
        "id": 1015,
        "name_th": "เขตธนบุรี",
        "name_en": "Khet Thon Buri",
        "province_id": 10
    },
    {
        "id": 1016,
        "name_th": "เขตบางกอกใหญ่",
        "name_en": "Khet Bangkok Yai",
        "province_id": 10
    },
    {
        "id": 1017,
        "name_th": "เขตห้วยขวาง",
        "name_en": "Khet Huai Khwang",
        "province_id": 10
    },
    {
        "id": 1018,
        "name_th": "เขตคลองสาน",
        "name_en": "Khet Khlong San",
        "province_id": 10
    },
    {
        "id": 1019,
        "name_th": "เขตตลิ่งชัน",
        "name_en": "Khet Taling Chan",
        "province_id": 10
    },
    {
        "id": 1020,
        "name_th": "เขตบางกอกน้อย",
        "name_en": "Khet Bangkok Noi",
        "province_id": 10
    },
    {
        "id": 1021,
        "name_th": "เขตบางขุนเทียน",
        "name_en": "Khet Bang Khun Thian",
        "province_id": 10
    },
    {
        "id": 1022,
        "name_th": "เขตภาษีเจริญ",
        "name_en": "Khet Phasi Charoen",
        "province_id": 10
    },
    {
        "id": 1023,
        "name_th": "เขตหนองแขม",
        "name_en": "Khet Nong Khaem",
        "province_id": 10
    },
    {
        "id": 1024,
        "name_th": "เขตราษฎร์บูรณะ",
        "name_en": "Khet Rat Burana",
        "province_id": 10
    },
    {
        "id": 1025,
        "name_th": "เขตบางพลัด",
        "name_en": "Khet Bang Phlat",
        "province_id": 10
    },
    {
        "id": 1026,
        "name_th": "เขตดินแดง",
        "name_en": "Khet Din Daeng",
        "province_id": 10
    },
    {
        "id": 1027,
        "name_th": "เขตบึงกุ่ม",
        "name_en": "Khet Bueng Kum",
        "province_id": 10
    },
    {
        "id": 1028,
        "name_th": "เขตสาทร",
        "name_en": "Khet Sathon",
        "province_id": 10
    },
    {
        "id": 1029,
        "name_th": "เขตบางซื่อ",
        "name_en": "Khet Bang Sue",
        "province_id": 10
    },
    {
        "id": 1030,
        "name_th": "เขตจตุจักร",
        "name_en": "Khet Chatuchak",
        "province_id": 10
    },
    {
        "id": 1031,
        "name_th": "เขตบางคอแหลม",
        "name_en": "Khet Bang Kho Laem",
        "province_id": 10
    },
    {
        "id": 1032,
        "name_th": "เขตประเวศ",
        "name_en": "Khet Prawet",
        "province_id": 10
    },
    {
        "id": 1033,
        "name_th": "เขตคลองเตย",
        "name_en": "Khet Khlong Toei",
        "province_id": 10
    },
    {
        "id": 1034,
        "name_th": "เขตสวนหลวง",
        "name_en": "Khet Suan Luang",
        "province_id": 10
    },
    {
        "id": 1035,
        "name_th": "เขตจอมทอง",
        "name_en": "Khet Chom Thong",
        "province_id": 10
    },
    {
        "id": 1036,
        "name_th": "เขตดอนเมือง",
        "name_en": "Khet Don Mueang",
        "province_id": 10
    },
    {
        "id": 1037,
        "name_th": "เขตราชเทวี",
        "name_en": "Khet Ratchathewi",
        "province_id": 10
    },
    {
        "id": 1038,
        "name_th": "เขตลาดพร้าว",
        "name_en": "Khet Lat Phrao",
        "province_id": 10
    },
    {
        "id": 1039,
        "name_th": "เขตวัฒนา",
        "name_en": "Khet Vadhana",
        "province_id": 10
    },
    {
        "id": 1040,
        "name_th": "เขตบางแค",
        "name_en": "Khet Bang Khae",
        "province_id": 10
    },
    {
        "id": 1041,
        "name_th": "เขตหลักสี่",
        "name_en": "Khet Lak Si",
        "province_id": 10
    },
    {
        "id": 1042,
        "name_th": "เขตสายไหม",
        "name_en": "Khet Sai Mai",
        "province_id": 10
    },
    {
        "id": 1043,
        "name_th": "เขตคันนายาว",
        "name_en": "Khet Khan Na Yao",
        "province_id": 10
    },
    {
        "id": 1044,
        "name_th": "เขตสะพานสูง",
        "name_en": "Khet Saphan Sung",
        "province_id": 10
    },
    {
        "id": 1045,
        "name_th": "เขตวังทองหลาง",
        "name_en": "Khet Wang Thonglang",
        "province_id": 10
    },
    {
        "id": 1046,
        "name_th": "เขตคลองสามวา",
        "name_en": "Khet Khlong Sam Wa",
        "province_id": 10
    },
    {
        "id": 1047,
        "name_th": "เขตบางนา",
        "name_en": "Khet Bang Na",
        "province_id": 10
    },
    {
        "id": 1048,
        "name_th": "เขตทวีวัฒนา",
        "name_en": "Khet Thawi Watthana",
        "province_id": 10
    },
    {
        "id": 1049,
        "name_th": "เขตทุ่งครุ",
        "name_en": "Khet Thung Khru",
        "province_id": 10
    },
    {
        "id": 1050,
        "name_th": "เขตบางบอน",
        "name_en": "Khet Bang Bon",
        "province_id": 10
    },
    {
        "id": 1101,
        "name_th": "อำเภอเมืองสมุทรปราการ",
        "name_en": "Amphoe Mueang Samut Prakan",
        "province_id": 11
    },
    {
        "id": 1102,
        "name_th": "อำเภอบางบ่อ",
        "name_en": "Amphoe Bang Bo",
        "province_id": 11
    },
    {
        "id": 1103,
        "name_th": "อำเภอบางพลี",
        "name_en": "Amphoe Bang Phli",
        "province_id": 11
    },
    {
        "id": 1104,
        "name_th": "อำเภอพระประแดง",
        "name_en": "Amphoe Phra Pradaeng",
        "province_id": 11
    },
    {
        "id": 1105,
        "name_th": "อำเภอพระสมุทรเจดีย์",
        "name_en": "Amphoe Phra Samut Chedi",
        "province_id": 11
    },
    {
        "id": 1106,
        "name_th": "อำเภอบางเสาธง",
        "name_en": "Amphoe Bang Sao Thong",
        "province_id": 11
    },
    {
        "id": 1201,
        "name_th": "อำเภอเมืองนนทบุรี",
        "name_en": "Amphoe Mueang Nonthaburi",
        "province_id": 12
    },
    {
        "id": 1202,
        "name_th": "อำเภอบางกรวย",
        "name_en": "Amphoe Bang Kruai",
        "province_id": 12
    },
    {
        "id": 1203,
        "name_th": "อำเภอบางใหญ่",
        "name_en": "Amphoe Bang Yai",
        "province_id": 12
    },
    {
        "id": 1204,
        "name_th": "อำเภอบางบัวทอง",
        "name_en": "Amphoe Bang Bua Thong",
        "province_id": 12
    },
    {
        "id": 1205,
        "name_th": "อำเภอไทรน้อย",
        "name_en": "Amphoe Sai Noi",
        "province_id": 12
    },
    {
        "id": 1206,
        "name_th": "อำเภอปากเกร็ด",
        "name_en": "Amphoe Pak Kret",
        "province_id": 12
    },
    {
        "id": 1301,
        "name_th": "อำเภอเมืองปทุมธานี",
        "name_en": "Amphoe Mueang Pathum Thani",
        "province_id": 13
    },
    {
        "id": 1302,
        "name_th": "อำเภอคลองหลวง",
        "name_en": "Amphoe Khlong Luang",
        "province_id": 13
    },
    {
        "id": 1303,
        "name_th": "อำเภอธัญบุรี",
        "name_en": "Amphoe Thanyaburi",
        "province_id": 13
    },
    {
        "id": 1304,
        "name_th": "อำเภอหนองเสือ",
        "name_en": "Amphoe Nong Suea",
        "province_id": 13
    },
    {
        "id": 1305,
        "name_th": "อำเภอลาดหลุมแก้ว",
        "name_en": "Amphoe Lat Lum Kaeo",
        "province_id": 13
    },
    {
        "id": 1306,
        "name_th": "อำเภอลำลูกกา",
        "name_en": "Amphoe Lam Luk Ka",
        "province_id": 13
    },
    {
        "id": 1307,
        "name_th": "อำเภอสามโคก",
        "name_en": "Amphoe Sam Khok",
        "province_id": 13
    },
    {
        "id": 1401,
        "name_th": "อำเภอพระนครศรีอยุธยา",
        "name_en": "Amphoe Phra Nakhon Si Ayutthaya",
        "province_id": 14
    },
    {
        "id": 1402,
        "name_th": "อำเภอท่าเรือ",
        "name_en": "Amphoe Tha Ruea",
        "province_id": 14
    },
    {
        "id": 1403,
        "name_th": "อำเภอนครหลวง",
        "name_en": "Amphoe Nakhon Luang",
        "province_id": 14
    },
    {
        "id": 1404,
        "name_th": "อำเภอบางไทร",
        "name_en": "Amphoe Bang Sai",
        "province_id": 14
    },
    {
        "id": 1405,
        "name_th": "อำเภอบางบาล",
        "name_en": "Amphoe Bang Ban",
        "province_id": 14
    },
    {
        "id": 1406,
        "name_th": "อำเภอบางปะอิน",
        "name_en": "Amphoe Bang Pa-in",
        "province_id": 14
    },
    {
        "id": 1407,
        "name_th": "อำเภอบางปะหัน",
        "name_en": "Amphoe Bang Pahan",
        "province_id": 14
    },
    {
        "id": 1408,
        "name_th": "อำเภอผักไห่",
        "name_en": "Amphoe Phak Hai",
        "province_id": 14
    },
    {
        "id": 1409,
        "name_th": "อำเภอภาชี",
        "name_en": "Amphoe Phachi",
        "province_id": 14
    },
    {
        "id": 1410,
        "name_th": "อำเภอลาดบัวหลวง",
        "name_en": "Amphoe Lat Bua Luang",
        "province_id": 14
    },
    {
        "id": 1411,
        "name_th": "อำเภอวังน้อย",
        "name_en": "Amphoe Wang Noi",
        "province_id": 14
    },
    {
        "id": 1412,
        "name_th": "อำเภอเสนา",
        "name_en": "Amphoe Sena",
        "province_id": 14
    },
    {
        "id": 1413,
        "name_th": "อำเภอบางซ้าย",
        "name_en": "Amphoe Bang Sai",
        "province_id": 14
    },
    {
        "id": 1414,
        "name_th": "อำเภออุทัย",
        "name_en": "Amphoe Uthai",
        "province_id": 14
    },
    {
        "id": 1415,
        "name_th": "อำเภอมหาราช",
        "name_en": "Amphoe Maha Rat",
        "province_id": 14
    },
    {
        "id": 1416,
        "name_th": "อำเภอบ้านแพรก",
        "name_en": "Amphoe Ban Phraek",
        "province_id": 14
    },
    {
        "id": 1501,
        "name_th": "อำเภอเมืองอ่างทอง",
        "name_en": "Amphoe Mueang Ang Thong",
        "province_id": 15
    },
    {
        "id": 1502,
        "name_th": "อำเภอไชโย",
        "name_en": "Amphoe Chaiyo",
        "province_id": 15
    },
    {
        "id": 1503,
        "name_th": "อำเภอป่าโมก",
        "name_en": "Amphoe Pa Mok",
        "province_id": 15
    },
    {
        "id": 1504,
        "name_th": "อำเภอโพธิ์ทอง",
        "name_en": "Amphoe Pho Thong",
        "province_id": 15
    },
    {
        "id": 1505,
        "name_th": "อำเภอแสวงหา",
        "name_en": "Amphoe Sawaeng Ha",
        "province_id": 15
    },
    {
        "id": 1506,
        "name_th": "อำเภอวิเศษชัยชาญ",
        "name_en": "Amphoe Wiset Chai Chan",
        "province_id": 15
    },
    {
        "id": 1507,
        "name_th": "อำเภอสามโก้",
        "name_en": "Amphoe Samko",
        "province_id": 15
    },
    {
        "id": 1601,
        "name_th": "อำเภอเมืองลพบุรี",
        "name_en": "Amphoe Mueang Lop Buri",
        "province_id": 16
    },
    {
        "id": 1602,
        "name_th": "อำเภอพัฒนานิคม",
        "name_en": "Amphoe Phatthana Nikhom",
        "province_id": 16
    },
    {
        "id": 1603,
        "name_th": "อำเภอโคกสำโรง",
        "name_en": "Amphoe Khok Samrong",
        "province_id": 16
    },
    {
        "id": 1604,
        "name_th": "อำเภอชัยบาดาล",
        "name_en": "Amphoe Chai Badan",
        "province_id": 16
    },
    {
        "id": 1605,
        "name_th": "อำเภอท่าวุ้ง",
        "name_en": "Amphoe Tha Wung",
        "province_id": 16
    },
    {
        "id": 1606,
        "name_th": "อำเภอบ้านหมี่",
        "name_en": "Amphoe Ban Mi",
        "province_id": 16
    },
    {
        "id": 1607,
        "name_th": "อำเภอท่าหลวง",
        "name_en": "Amphoe Tha Luang",
        "province_id": 16
    },
    {
        "id": 1608,
        "name_th": "อำเภอสระโบสถ์",
        "name_en": "Amphoe Sa Bot",
        "province_id": 16
    },
    {
        "id": 1609,
        "name_th": "อำเภอโคกเจริญ",
        "name_en": "Amphoe Khok Charoen",
        "province_id": 16
    },
    {
        "id": 1610,
        "name_th": "อำเภอลำสนธิ",
        "name_en": "Amphoe Lam Sonthi",
        "province_id": 16
    },
    {
        "id": 1611,
        "name_th": "อำเภอหนองม่วง",
        "name_en": "Amphoe Nong Muang",
        "province_id": 16
    },
    {
        "id": 1701,
        "name_th": "อำเภอเมืองสิงห์บุรี",
        "name_en": "Amphoe Mueang Sing Buri",
        "province_id": 17
    },
    {
        "id": 1702,
        "name_th": "อำเภอบางระจัน",
        "name_en": "Amphoe Bang Rachan",
        "province_id": 17
    },
    {
        "id": 1703,
        "name_th": "อำเภอค่ายบางระจัน",
        "name_en": "Amphoe Khai Bang Rachan",
        "province_id": 17
    },
    {
        "id": 1704,
        "name_th": "อำเภอพรหมบุรี",
        "name_en": "Amphoe Phrom Buri",
        "province_id": 17
    },
    {
        "id": 1705,
        "name_th": "อำเภอท่าช้าง",
        "name_en": "Amphoe Tha Chang",
        "province_id": 17
    },
    {
        "id": 1706,
        "name_th": "อำเภออินทร์บุรี",
        "name_en": "Amphoe In Buri",
        "province_id": 17
    },
    {
        "id": 1801,
        "name_th": "อำเภอเมืองชัยนาท",
        "name_en": "Amphoe Mueang Chai Nat",
        "province_id": 18
    },
    {
        "id": 1802,
        "name_th": "อำเภอมโนรมย์",
        "name_en": "Amphoe Manorom",
        "province_id": 18
    },
    {
        "id": 1803,
        "name_th": "อำเภอวัดสิงห์",
        "name_en": "Amphoe Wat Sing",
        "province_id": 18
    },
    {
        "id": 1804,
        "name_th": "อำเภอสรรพยา",
        "name_en": "Amphoe Sapphaya",
        "province_id": 18
    },
    {
        "id": 1805,
        "name_th": "อำเภอสรรคบุรี",
        "name_en": "Amphoe Sankhaburi",
        "province_id": 18
    },
    {
        "id": 1806,
        "name_th": "อำเภอหันคา",
        "name_en": "Amphoe Hankha",
        "province_id": 18
    },
    {
        "id": 1807,
        "name_th": "อำเภอหนองมะโมง",
        "name_en": "Amphoe Nong Mamong",
        "province_id": 18
    },
    {
        "id": 1808,
        "name_th": "อำเภอเนินขาม",
        "name_en": "Amphoe Noen Kham",
        "province_id": 18
    },
    {
        "id": 1901,
        "name_th": "อำเภอเมืองสระบุรี",
        "name_en": "Amphoe Mueang Saraburi",
        "province_id": 19
    },
    {
        "id": 1902,
        "name_th": "อำเภอแก่งคอย",
        "name_en": "Amphoe Kaeng Khoi",
        "province_id": 19
    },
    {
        "id": 1903,
        "name_th": "อำเภอหนองแค",
        "name_en": "Amphoe Nong Khae",
        "province_id": 19
    },
    {
        "id": 1904,
        "name_th": "อำเภอวิหารแดง",
        "name_en": "Amphoe Wihan Daeng",
        "province_id": 19
    },
    {
        "id": 1905,
        "name_th": "อำเภอหนองแซง",
        "name_en": "Amphoe Nong Saeng",
        "province_id": 19
    },
    {
        "id": 1906,
        "name_th": "อำเภอบ้านหมอ",
        "name_en": "Amphoe Ban Mo",
        "province_id": 19
    },
    {
        "id": 1907,
        "name_th": "อำเภอดอนพุด",
        "name_en": "Amphoe Don Phut",
        "province_id": 19
    },
    {
        "id": 1908,
        "name_th": "อำเภอหนองโดน",
        "name_en": "Amphoe Nong Don",
        "province_id": 19
    },
    {
        "id": 1909,
        "name_th": "อำเภอพระพุทธบาท",
        "name_en": "Amphoe Phra Phutthabat",
        "province_id": 19
    },
    {
        "id": 1910,
        "name_th": "อำเภอเสาไห้",
        "name_en": "Amphoe Sao Hai",
        "province_id": 19
    },
    {
        "id": 1911,
        "name_th": "อำเภอมวกเหล็ก",
        "name_en": "Amphoe Muak Lek",
        "province_id": 19
    },
    {
        "id": 1912,
        "name_th": "อำเภอวังม่วง",
        "name_en": "Amphoe Wang Muang",
        "province_id": 19
    },
    {
        "id": 1913,
        "name_th": "อำเภอเฉลิมพระเกียรติ",
        "name_en": "Amphoe Chaloem Phra Kiat",
        "province_id": 19
    },
    {
        "id": 2001,
        "name_th": "อำเภอเมืองชลบุรี",
        "name_en": "Amphoe Mueang Chon Buri",
        "province_id": 20
    },
    {
        "id": 2002,
        "name_th": "อำเภอบ้านบึง",
        "name_en": "Amphoe Ban Bueng",
        "province_id": 20
    },
    {
        "id": 2003,
        "name_th": "อำเภอหนองใหญ่",
        "name_en": "Amphoe Nong Yai",
        "province_id": 20
    },
    {
        "id": 2004,
        "name_th": "อำเภอบางละมุง",
        "name_en": "Amphoe Bang Lamung",
        "province_id": 20
    },
    {
        "id": 2005,
        "name_th": "อำเภอพานทอง",
        "name_en": "Amphoe Phan Thong",
        "province_id": 20
    },
    {
        "id": 2006,
        "name_th": "อำเภอพนัสนิคม",
        "name_en": "Amphoe Phanat Nikhom",
        "province_id": 20
    },
    {
        "id": 2007,
        "name_th": "อำเภอศรีราชา",
        "name_en": "Amphoe Si Racha",
        "province_id": 20
    },
    {
        "id": 2008,
        "name_th": "อำเภอเกาะสีชัง",
        "name_en": "Amphoe Ko Sichang",
        "province_id": 20
    },
    {
        "id": 2009,
        "name_th": "อำเภอสัตหีบ",
        "name_en": "Amphoe Sattahip",
        "province_id": 20
    },
    {
        "id": 2010,
        "name_th": "อำเภอบ่อทอง",
        "name_en": "Amphoe Bo Thong",
        "province_id": 20
    },
    {
        "id": 2011,
        "name_th": "อำเภอเกาะจันทร์",
        "name_en": "Amphoe Ko Chan",
        "province_id": 20
    },
    {
        "id": 2101,
        "name_th": "อำเภอเมืองระยอง",
        "name_en": "Amphoe Mueang Rayong",
        "province_id": 21
    },
    {
        "id": 2102,
        "name_th": "อำเภอบ้านฉาง",
        "name_en": "Amphoe Ban Chang",
        "province_id": 21
    },
    {
        "id": 2103,
        "name_th": "อำเภอแกลง",
        "name_en": "Amphoe Klaeng",
        "province_id": 21
    },
    {
        "id": 2104,
        "name_th": "อำเภอวังจันทร์",
        "name_en": "Amphoe Wang Chan",
        "province_id": 21
    },
    {
        "id": 2105,
        "name_th": "อำเภอบ้านค่าย",
        "name_en": "Amphoe Ban Khai",
        "province_id": 21
    },
    {
        "id": 2106,
        "name_th": "อำเภอปลวกแดง",
        "name_en": "Amphoe Pluak Daeng",
        "province_id": 21
    },
    {
        "id": 2107,
        "name_th": "อำเภอเขาชะเมา",
        "name_en": "Amphoe Khao Chamao",
        "province_id": 21
    },
    {
        "id": 2108,
        "name_th": "อำเภอนิคมพัฒนา",
        "name_en": "Amphoe Nikhom Phatthana",
        "province_id": 21
    },
    {
        "id": 2201,
        "name_th": "อำเภอเมืองจันทบุรี",
        "name_en": "Amphoe Mueang Chanthaburi",
        "province_id": 22
    },
    {
        "id": 2202,
        "name_th": "อำเภอขลุง",
        "name_en": "Amphoe Khlung",
        "province_id": 22
    },
    {
        "id": 2203,
        "name_th": "อำเภอท่าใหม่",
        "name_en": "Amphoe Tha Mai",
        "province_id": 22
    },
    {
        "id": 2204,
        "name_th": "อำเภอโป่งน้ำร้อน",
        "name_en": "Amphoe Pong Nam Ron",
        "province_id": 22
    },
    {
        "id": 2205,
        "name_th": "อำเภอมะขาม",
        "name_en": "Amphoe Makham",
        "province_id": 22
    },
    {
        "id": 2206,
        "name_th": "อำเภอแหลมสิงห์",
        "name_en": "Amphoe Laem Sing",
        "province_id": 22
    },
    {
        "id": 2207,
        "name_th": "อำเภอสอยดาว",
        "name_en": "Amphoe Soi Dao",
        "province_id": 22
    },
    {
        "id": 2208,
        "name_th": "อำเภอแก่งหางแมว",
        "name_en": "Amphoe Kaeng Hang Maeo",
        "province_id": 22
    },
    {
        "id": 2209,
        "name_th": "อำเภอนายายอาม",
        "name_en": "Amphoe Na Yai Am",
        "province_id": 22
    },
    {
        "id": 2210,
        "name_th": "อำเภอเขาคิชฌกูฏ",
        "name_en": "Amphoe Khao Khitchakut",
        "province_id": 22
    },
    {
        "id": 2301,
        "name_th": "อำเภอเมืองตราด",
        "name_en": "Amphoe Mueang Trat",
        "province_id": 23
    },
    {
        "id": 2302,
        "name_th": "อำเภอคลองใหญ่",
        "name_en": "Amphoe Khlong Yai",
        "province_id": 23
    },
    {
        "id": 2303,
        "name_th": "อำเภอเขาสมิง",
        "name_en": "Amphoe Khao Saming",
        "province_id": 23
    },
    {
        "id": 2304,
        "name_th": "อำเภอบ่อไร่",
        "name_en": "Amphoe Bo Rai",
        "province_id": 23
    },
    {
        "id": 2305,
        "name_th": "อำเภอแหลมงอบ",
        "name_en": "Amphoe Laem Ngop",
        "province_id": 23
    },
    {
        "id": 2306,
        "name_th": "อำเภอเกาะกูด",
        "name_en": "Amphoe Ko Kut",
        "province_id": 23
    },
    {
        "id": 2307,
        "name_th": "อำเภอเกาะช้าง",
        "name_en": "Amphoe Ko Chang",
        "province_id": 23
    },
    {
        "id": 2401,
        "name_th": "อำเภอเมืองฉะเชิงเทรา",
        "name_en": "Amphoe Mueang Chachoengsao",
        "province_id": 24
    },
    {
        "id": 2402,
        "name_th": "อำเภอบางคล้า",
        "name_en": "Amphoe Bang Khla",
        "province_id": 24
    },
    {
        "id": 2403,
        "name_th": "อำเภอบางน้ำเปรี้ยว",
        "name_en": "Amphoe Bang Nam Priao",
        "province_id": 24
    },
    {
        "id": 2404,
        "name_th": "อำเภอบางปะกง",
        "name_en": "Amphoe Bang Pakong",
        "province_id": 24
    },
    {
        "id": 2405,
        "name_th": "อำเภอบ้านโพธิ์",
        "name_en": "Amphoe Ban Pho",
        "province_id": 24
    },
    {
        "id": 2406,
        "name_th": "อำเภอพนมสารคาม",
        "name_en": "Amphoe Phanom Sarakham",
        "province_id": 24
    },
    {
        "id": 2407,
        "name_th": "อำเภอราชสาส์น",
        "name_en": "Amphoe Ratchasan",
        "province_id": 24
    },
    {
        "id": 2408,
        "name_th": "อำเภอสนามชัยเขต",
        "name_en": "Amphoe Sanam Chai Khet",
        "province_id": 24
    },
    {
        "id": 2409,
        "name_th": "อำเภอแปลงยาว",
        "name_en": "Amphoe Plaeng Yao",
        "province_id": 24
    },
    {
        "id": 2410,
        "name_th": "อำเภอท่าตะเกียบ",
        "name_en": "Amphoe Tha Takiap",
        "province_id": 24
    },
    {
        "id": 2411,
        "name_th": "อำเภอคลองเขื่อน",
        "name_en": "Amphoe Khlong Khuean",
        "province_id": 24
    },
    {
        "id": 2501,
        "name_th": "อำเภอเมืองปราจีนบุรี",
        "name_en": "Amphoe Mueang Prachin Buri",
        "province_id": 25
    },
    {
        "id": 2502,
        "name_th": "อำเภอกบินทร์บุรี",
        "name_en": "Amphoe Kabin Buri",
        "province_id": 25
    },
    {
        "id": 2503,
        "name_th": "อำเภอนาดี",
        "name_en": "Amphoe Na Di",
        "province_id": 25
    },
    {
        "id": 2506,
        "name_th": "อำเภอบ้านสร้าง",
        "name_en": "Amphoe Ban Sang",
        "province_id": 25
    },
    {
        "id": 2507,
        "name_th": "อำเภอประจันตคาม",
        "name_en": "Amphoe Prachantakham",
        "province_id": 25
    },
    {
        "id": 2508,
        "name_th": "อำเภอศรีมหาโพธิ",
        "name_en": "Amphoe Si Maha Phot",
        "province_id": 25
    },
    {
        "id": 2509,
        "name_th": "อำเภอศรีมโหสถ",
        "name_en": "Amphoe Si Mahosot",
        "province_id": 25
    },
    {
        "id": 2601,
        "name_th": "อำเภอเมืองนครนายก",
        "name_en": "Amphoe Mueang Nakhon Nayok",
        "province_id": 26
    },
    {
        "id": 2602,
        "name_th": "อำเภอปากพลี",
        "name_en": "Amphoe Pak Phli",
        "province_id": 26
    },
    {
        "id": 2603,
        "name_th": "อำเภอบ้านนา",
        "name_en": "Amphoe Ban Na",
        "province_id": 26
    },
    {
        "id": 2604,
        "name_th": "อำเภอองครักษ์",
        "name_en": "Amphoe Ongkharak",
        "province_id": 26
    },
    {
        "id": 2701,
        "name_th": "อำเภอเมืองสระแก้ว",
        "name_en": "Amphoe Mueang Sa Kaeo",
        "province_id": 27
    },
    {
        "id": 2702,
        "name_th": "อำเภอคลองหาด",
        "name_en": "Amphoe Khlong Hat",
        "province_id": 27
    },
    {
        "id": 2703,
        "name_th": "อำเภอตาพระยา",
        "name_en": "Amphoe Ta Phraya",
        "province_id": 27
    },
    {
        "id": 2704,
        "name_th": "อำเภอวังน้ำเย็น",
        "name_en": "Amphoe Wang Nam Yen",
        "province_id": 27
    },
    {
        "id": 2705,
        "name_th": "อำเภอวัฒนานคร",
        "name_en": "Amphoe Watthana Nakhon",
        "province_id": 27
    },
    {
        "id": 2706,
        "name_th": "อำเภออรัญประเทศ",
        "name_en": "Amphoe Aranyaprathet",
        "province_id": 27
    },
    {
        "id": 2707,
        "name_th": "อำเภอเขาฉกรรจ์",
        "name_en": "Amphoe Khao Chakan",
        "province_id": 27
    },
    {
        "id": 2708,
        "name_th": "อำเภอโคกสูง",
        "name_en": "Amphoe Khok Sung",
        "province_id": 27
    },
    {
        "id": 2709,
        "name_th": "อำเภอวังสมบูรณ์",
        "name_en": "Amphoe Wang Sombun",
        "province_id": 27
    },
    {
        "id": 3001,
        "name_th": "อำเภอเมืองนครราชสีมา",
        "name_en": "Amphoe Mueang Nakhon Ratchasima",
        "province_id": 30
    },
    {
        "id": 3002,
        "name_th": "อำเภอครบุรี",
        "name_en": "Amphoe Khon Buri",
        "province_id": 30
    },
    {
        "id": 3003,
        "name_th": "อำเภอเสิงสาง",
        "name_en": "Amphoe Soeng Sang",
        "province_id": 30
    },
    {
        "id": 3004,
        "name_th": "อำเภอคง",
        "name_en": "Amphoe Khong",
        "province_id": 30
    },
    {
        "id": 3005,
        "name_th": "อำเภอบ้านเหลื่อม",
        "name_en": "Amphoe Ban Lueam",
        "province_id": 30
    },
    {
        "id": 3006,
        "name_th": "อำเภอจักราช",
        "name_en": "Amphoe Chakkarat",
        "province_id": 30
    },
    {
        "id": 3007,
        "name_th": "อำเภอโชคชัย",
        "name_en": "Amphoe Chok Chai",
        "province_id": 30
    },
    {
        "id": 3008,
        "name_th": "อำเภอด่านขุนทด",
        "name_en": "Amphoe Dan Khun Thot",
        "province_id": 30
    },
    {
        "id": 3009,
        "name_th": "อำเภอโนนไทย",
        "name_en": "Amphoe Non Thai",
        "province_id": 30
    },
    {
        "id": 3010,
        "name_th": "อำเภอโนนสูง",
        "name_en": "Amphoe Non Sung",
        "province_id": 30
    },
    {
        "id": 3011,
        "name_th": "อำเภอขามสะแกแสง",
        "name_en": "Amphoe Kham Sakaesaeng",
        "province_id": 30
    },
    {
        "id": 3012,
        "name_th": "อำเภอบัวใหญ่",
        "name_en": "Amphoe Bua Yai",
        "province_id": 30
    },
    {
        "id": 3013,
        "name_th": "อำเภอประทาย",
        "name_en": "Amphoe Prathai",
        "province_id": 30
    },
    {
        "id": 3014,
        "name_th": "อำเภอปักธงชัย",
        "name_en": "Amphoe Pak Thong Chai",
        "province_id": 30
    },
    {
        "id": 3015,
        "name_th": "อำเภอพิมาย",
        "name_en": "Amphoe Phimai",
        "province_id": 30
    },
    {
        "id": 3016,
        "name_th": "อำเภอห้วยแถลง",
        "name_en": "Amphoe Huai Thalaeng",
        "province_id": 30
    },
    {
        "id": 3017,
        "name_th": "อำเภอชุมพวง",
        "name_en": "Amphoe Chum Phuang",
        "province_id": 30
    },
    {
        "id": 3018,
        "name_th": "อำเภอสูงเนิน",
        "name_en": "Amphoe Sung Noen",
        "province_id": 30
    },
    {
        "id": 3019,
        "name_th": "อำเภอขามทะเลสอ",
        "name_en": "Amphoe Kham Thale So",
        "province_id": 30
    },
    {
        "id": 3020,
        "name_th": "อำเภอสีคิ้ว",
        "name_en": "Amphoe Sikhio",
        "province_id": 30
    },
    {
        "id": 3021,
        "name_th": "อำเภอปากช่อง",
        "name_en": "Amphoe Pak Chong",
        "province_id": 30
    },
    {
        "id": 3022,
        "name_th": "อำเภอหนองบุญมาก",
        "name_en": "Amphoe Nong Bunmak",
        "province_id": 30
    },
    {
        "id": 3023,
        "name_th": "อำเภอแก้งสนามนาง",
        "name_en": "Amphoe Kaeng Sanam Nang",
        "province_id": 30
    },
    {
        "id": 3024,
        "name_th": "อำเภอโนนแดง",
        "name_en": "Amphoe Non Daeng",
        "province_id": 30
    },
    {
        "id": 3025,
        "name_th": "อำเภอวังน้ำเขียว",
        "name_en": "Amphoe Wang Nam Khiao",
        "province_id": 30
    },
    {
        "id": 3026,
        "name_th": "อำเภอเทพารักษ์",
        "name_en": "Amphoe Thepharak",
        "province_id": 30
    },
    {
        "id": 3027,
        "name_th": "อำเภอเมืองยาง",
        "name_en": "Amphoe Mueang Yang",
        "province_id": 30
    },
    {
        "id": 3028,
        "name_th": "อำเภอพระทองคำ",
        "name_en": "Amphoe Phra Thong Kham",
        "province_id": 30
    },
    {
        "id": 3029,
        "name_th": "อำเภอลำทะเมนชัย",
        "name_en": "Amphoe Lam Thamenchai",
        "province_id": 30
    },
    {
        "id": 3030,
        "name_th": "อำเภอบัวลาย",
        "name_en": "Amphoe Bua Lai",
        "province_id": 30
    },
    {
        "id": 3031,
        "name_th": "อำเภอสีดา",
        "name_en": "Amphoe Sida",
        "province_id": 30
    },
    {
        "id": 3032,
        "name_th": "อำเภอเฉลิมพระเกียรติ",
        "name_en": "Amphoe Chaloem Phra Kiat",
        "province_id": 30
    },
    {
        "id": 3101,
        "name_th": "อำเภอเมืองบุรีรัมย์",
        "name_en": "Amphoe Mueang Buri Ram",
        "province_id": 31
    },
    {
        "id": 3102,
        "name_th": "อำเภอคูเมือง",
        "name_en": "Amphoe Khu Mueang",
        "province_id": 31
    },
    {
        "id": 3103,
        "name_th": "อำเภอกระสัง",
        "name_en": "Amphoe Krasang",
        "province_id": 31
    },
    {
        "id": 3104,
        "name_th": "อำเภอนางรอง",
        "name_en": "Amphoe Nang Rong",
        "province_id": 31
    },
    {
        "id": 3105,
        "name_th": "อำเภอหนองกี่",
        "name_en": "Amphoe Nong Ki",
        "province_id": 31
    },
    {
        "id": 3106,
        "name_th": "อำเภอละหานทราย",
        "name_en": "Amphoe Lahan Sai",
        "province_id": 31
    },
    {
        "id": 3107,
        "name_th": "อำเภอประโคนชัย",
        "name_en": "Amphoe Prakhon Chai",
        "province_id": 31
    },
    {
        "id": 3108,
        "name_th": "อำเภอบ้านกรวด",
        "name_en": "Amphoe Ban Kruat",
        "province_id": 31
    },
    {
        "id": 3109,
        "name_th": "อำเภอพุทไธสง",
        "name_en": "Amphoe Phutthaisong",
        "province_id": 31
    },
    {
        "id": 3110,
        "name_th": "อำเภอลำปลายมาศ",
        "name_en": "Amphoe Lam Plai Mat",
        "province_id": 31
    },
    {
        "id": 3111,
        "name_th": "อำเภอสตึก",
        "name_en": "Amphoe Satuek",
        "province_id": 31
    },
    {
        "id": 3112,
        "name_th": "อำเภอปะคำ",
        "name_en": "Amphoe Pakham",
        "province_id": 31
    },
    {
        "id": 3113,
        "name_th": "อำเภอนาโพธิ์",
        "name_en": "Amphoe Na Pho",
        "province_id": 31
    },
    {
        "id": 3114,
        "name_th": "อำเภอหนองหงส์",
        "name_en": "Amphoe Nong Hong",
        "province_id": 31
    },
    {
        "id": 3115,
        "name_th": "อำเภอพลับพลาชัย",
        "name_en": "Amphoe Phlapphla Chai",
        "province_id": 31
    },
    {
        "id": 3116,
        "name_th": "อำเภอห้วยราช",
        "name_en": "Amphoe Huai Rat",
        "province_id": 31
    },
    {
        "id": 3117,
        "name_th": "อำเภอโนนสุวรรณ",
        "name_en": "Amphoe Non Suwan",
        "province_id": 31
    },
    {
        "id": 3118,
        "name_th": "อำเภอชำนิ",
        "name_en": "Amphoe Chamni",
        "province_id": 31
    },
    {
        "id": 3119,
        "name_th": "อำเภอบ้านใหม่ไชยพจน์",
        "name_en": "Amphoe Ban Mai Chaiyaphot",
        "province_id": 31
    },
    {
        "id": 3120,
        "name_th": "อำเภอโนนดินแดง",
        "name_en": "Amphoe Non Din Daeng",
        "province_id": 31
    },
    {
        "id": 3121,
        "name_th": "อำเภอบ้านด่าน",
        "name_en": "Amphoe Ban Dan",
        "province_id": 31
    },
    {
        "id": 3122,
        "name_th": "อำเภอแคนดง",
        "name_en": "Amphoe Khaen Dong",
        "province_id": 31
    },
    {
        "id": 3123,
        "name_th": "อำเภอเฉลิมพระเกียรติ",
        "name_en": "Amphoe Chaloem Phra Kiat",
        "province_id": 31
    },
    {
        "id": 3201,
        "name_th": "อำเภอเมืองสุรินทร์",
        "name_en": "Amphoe Mueang Surin",
        "province_id": 32
    },
    {
        "id": 3202,
        "name_th": "อำเภอชุมพลบุรี",
        "name_en": "Amphoe Chumphon Buri",
        "province_id": 32
    },
    {
        "id": 3203,
        "name_th": "อำเภอท่าตูม",
        "name_en": "Amphoe Tha Tum",
        "province_id": 32
    },
    {
        "id": 3204,
        "name_th": "อำเภอจอมพระ",
        "name_en": "Amphoe Chom Phra",
        "province_id": 32
    },
    {
        "id": 3205,
        "name_th": "อำเภอปราสาท",
        "name_en": "Amphoe Prasat",
        "province_id": 32
    },
    {
        "id": 3206,
        "name_th": "อำเภอกาบเชิง",
        "name_en": "Amphoe Kap Choeng",
        "province_id": 32
    },
    {
        "id": 3207,
        "name_th": "อำเภอรัตนบุรี",
        "name_en": "Amphoe Rattanaburi",
        "province_id": 32
    },
    {
        "id": 3208,
        "name_th": "อำเภอสนม",
        "name_en": "Amphoe Sanom",
        "province_id": 32
    },
    {
        "id": 3209,
        "name_th": "อำเภอศีขรภูมิ",
        "name_en": "Amphoe Sikhoraphum",
        "province_id": 32
    },
    {
        "id": 3210,
        "name_th": "อำเภอสังขะ",
        "name_en": "Amphoe Sangkha",
        "province_id": 32
    },
    {
        "id": 3211,
        "name_th": "อำเภอลำดวน",
        "name_en": "Amphoe Lamduan",
        "province_id": 32
    },
    {
        "id": 3212,
        "name_th": "อำเภอสำโรงทาบ",
        "name_en": "Amphoe Samrong Thap",
        "province_id": 32
    },
    {
        "id": 3213,
        "name_th": "อำเภอบัวเชด",
        "name_en": "Amphoe Buachet",
        "province_id": 32
    },
    {
        "id": 3214,
        "name_th": "อำเภอพนมดงรัก",
        "name_en": "Amphoe Phanom Dong Rak",
        "province_id": 32
    },
    {
        "id": 3215,
        "name_th": "อำเภอศรีณรงค์",
        "name_en": "Amphoe Si Narong",
        "province_id": 32
    },
    {
        "id": 3216,
        "name_th": "อำเภอเขวาสินรินทร์",
        "name_en": "Amphoe Khwao Sinrin",
        "province_id": 32
    },
    {
        "id": 3217,
        "name_th": "อำเภอโนนนารายณ์",
        "name_en": "Amphoe Non Narai",
        "province_id": 32
    },
    {
        "id": 3301,
        "name_th": "อำเภอเมืองศรีสะเกษ",
        "name_en": "Amphoe Mueang Si Sa Ket",
        "province_id": 33
    },
    {
        "id": 3302,
        "name_th": "อำเภอยางชุมน้อย",
        "name_en": "Amphoe Yang Chum Noi",
        "province_id": 33
    },
    {
        "id": 3303,
        "name_th": "อำเภอกันทรารมย์",
        "name_en": "Amphoe Kanthararom",
        "province_id": 33
    },
    {
        "id": 3304,
        "name_th": "อำเภอกันทรลักษ์",
        "name_en": "Amphoe Kantharalak",
        "province_id": 33
    },
    {
        "id": 3305,
        "name_th": "อำเภอขุขันธ์",
        "name_en": "Amphoe Khukhan",
        "province_id": 33
    },
    {
        "id": 3306,
        "name_th": "อำเภอไพรบึง",
        "name_en": "Amphoe Phrai Bueng",
        "province_id": 33
    },
    {
        "id": 3307,
        "name_th": "อำเภอปรางค์กู่",
        "name_en": "Amphoe Prang Ku",
        "province_id": 33
    },
    {
        "id": 3308,
        "name_th": "อำเภอขุนหาญ",
        "name_en": "Amphoe Khun Han",
        "province_id": 33
    },
    {
        "id": 3309,
        "name_th": "อำเภอราษีไศล",
        "name_en": "Amphoe Rasi Salai",
        "province_id": 33
    },
    {
        "id": 3310,
        "name_th": "อำเภออุทุมพรพิสัย",
        "name_en": "Amphoe Uthumphon Phisai",
        "province_id": 33
    },
    {
        "id": 3311,
        "name_th": "อำเภอบึงบูรพ์",
        "name_en": "Amphoe Bueng Bun",
        "province_id": 33
    },
    {
        "id": 3312,
        "name_th": "อำเภอห้วยทับทัน",
        "name_en": "Amphoe Huai Thap Than",
        "province_id": 33
    },
    {
        "id": 3313,
        "name_th": "อำเภอโนนคูณ",
        "name_en": "Amphoe Non Khun",
        "province_id": 33
    },
    {
        "id": 3314,
        "name_th": "อำเภอศรีรัตนะ",
        "name_en": "Amphoe Si Rattana",
        "province_id": 33
    },
    {
        "id": 3315,
        "name_th": "อำเภอน้ำเกลี้ยง",
        "name_en": "Amphoe Nam Kliang",
        "province_id": 33
    },
    {
        "id": 3316,
        "name_th": "อำเภอวังหิน",
        "name_en": "Amphoe Wang Hin",
        "province_id": 33
    },
    {
        "id": 3317,
        "name_th": "อำเภอภูสิงห์",
        "name_en": "Amphoe Phu Sing",
        "province_id": 33
    },
    {
        "id": 3318,
        "name_th": "อำเภอเมืองจันทร์",
        "name_en": "Amphoe Mueang Chan",
        "province_id": 33
    },
    {
        "id": 3319,
        "name_th": "อำเภอเบญจลักษ์",
        "name_en": "Amphoe Benchalak",
        "province_id": 33
    },
    {
        "id": 3320,
        "name_th": "อำเภอพยุห์",
        "name_en": "Amphoe Phayu",
        "province_id": 33
    },
    {
        "id": 3321,
        "name_th": "อำเภอโพธิ์ศรีสุวรรณ",
        "name_en": "Amphoe Pho Si Suwan",
        "province_id": 33
    },
    {
        "id": 3322,
        "name_th": "อำเภอศิลาลาด",
        "name_en": "Amphoe Sila Lat",
        "province_id": 33
    },
    {
        "id": 3401,
        "name_th": "อำเภอเมืองอุบลราชธานี",
        "name_en": "Amphoe Mueang Ubon Ratchathani",
        "province_id": 34
    },
    {
        "id": 3402,
        "name_th": "อำเภอศรีเมืองใหม่",
        "name_en": "Amphoe Si Mueang Mai",
        "province_id": 34
    },
    {
        "id": 3403,
        "name_th": "อำเภอโขงเจียม",
        "name_en": "Amphoe Khong Chiam",
        "province_id": 34
    },
    {
        "id": 3404,
        "name_th": "อำเภอเขื่องใน",
        "name_en": "Amphoe Khueang Nai",
        "province_id": 34
    },
    {
        "id": 3405,
        "name_th": "อำเภอเขมราฐ",
        "name_en": "Amphoe Khemarat",
        "province_id": 34
    },
    {
        "id": 3407,
        "name_th": "อำเภอเดชอุดม",
        "name_en": "Amphoe Det Udom",
        "province_id": 34
    },
    {
        "id": 3408,
        "name_th": "อำเภอนาจะหลวย",
        "name_en": "Amphoe Na Chaluai",
        "province_id": 34
    },
    {
        "id": 3409,
        "name_th": "อำเภอน้ำยืน",
        "name_en": "Amphoe Nam Yuen",
        "province_id": 34
    },
    {
        "id": 3410,
        "name_th": "อำเภอบุณฑริก",
        "name_en": "Amphoe Buntharik",
        "province_id": 34
    },
    {
        "id": 3411,
        "name_th": "อำเภอตระการพืชผล",
        "name_en": "Amphoe Trakan Phuet Phon",
        "province_id": 34
    },
    {
        "id": 3412,
        "name_th": "อำเภอกุดข้าวปุ้น",
        "name_en": "Amphoe Kut Khaopun",
        "province_id": 34
    },
    {
        "id": 3414,
        "name_th": "อำเภอม่วงสามสิบ",
        "name_en": "Amphoe Muang Sam Sip",
        "province_id": 34
    },
    {
        "id": 3415,
        "name_th": "อำเภอวารินชำราบ",
        "name_en": "Amphoe Warin Chamrap",
        "province_id": 34
    },
    {
        "id": 3419,
        "name_th": "อำเภอพิบูลมังสาหาร",
        "name_en": "Amphoe Phibun Mangsahan",
        "province_id": 34
    },
    {
        "id": 3420,
        "name_th": "อำเภอตาลสุม",
        "name_en": "Amphoe Tan Sum",
        "province_id": 34
    },
    {
        "id": 3421,
        "name_th": "อำเภอโพธิ์ไทร",
        "name_en": "Amphoe Pho Sai",
        "province_id": 34
    },
    {
        "id": 3422,
        "name_th": "อำเภอสำโรง",
        "name_en": "Amphoe Samrong",
        "province_id": 34
    },
    {
        "id": 3424,
        "name_th": "อำเภอดอนมดแดง",
        "name_en": "Amphoe Don Mot Daeng",
        "province_id": 34
    },
    {
        "id": 3425,
        "name_th": "อำเภอสิรินธร",
        "name_en": "Amphoe Sirindhorn",
        "province_id": 34
    },
    {
        "id": 3426,
        "name_th": "อำเภอทุ่งศรีอุดม",
        "name_en": "Amphoe Thung Si Udom",
        "province_id": 34
    },
    {
        "id": 3429,
        "name_th": "อำเภอนาเยีย",
        "name_en": "Amphoe Na Yia",
        "province_id": 34
    },
    {
        "id": 3430,
        "name_th": "อำเภอนาตาล",
        "name_en": "Amphoe Na Tan",
        "province_id": 34
    },
    {
        "id": 3431,
        "name_th": "อำเภอเหล่าเสือโก้ก",
        "name_en": "Amphoe Lao Suea Kok",
        "province_id": 34
    },
    {
        "id": 3432,
        "name_th": "อำเภอสว่างวีระวงศ์",
        "name_en": "Amphoe Sawang Wirawong",
        "province_id": 34
    },
    {
        "id": 3433,
        "name_th": "อำเภอน้ำขุ่น",
        "name_en": "Amphoe Nam Khun",
        "province_id": 34
    },
    {
        "id": 3501,
        "name_th": "อำเภอเมืองยโสธร",
        "name_en": "Amphoe Mueang Yasothon",
        "province_id": 35
    },
    {
        "id": 3502,
        "name_th": "อำเภอทรายมูล",
        "name_en": "Amphoe Sai Mun",
        "province_id": 35
    },
    {
        "id": 3503,
        "name_th": "อำเภอกุดชุม",
        "name_en": "Amphoe Kut Chum",
        "province_id": 35
    },
    {
        "id": 3504,
        "name_th": "อำเภอคำเขื่อนแก้ว",
        "name_en": "Amphoe Kham Khuean Kaeo",
        "province_id": 35
    },
    {
        "id": 3505,
        "name_th": "อำเภอป่าติ้ว",
        "name_en": "Amphoe Pa Tio",
        "province_id": 35
    },
    {
        "id": 3506,
        "name_th": "อำเภอมหาชนะชัย",
        "name_en": "Amphoe Maha Chana Chai",
        "province_id": 35
    },
    {
        "id": 3507,
        "name_th": "อำเภอค้อวัง",
        "name_en": "Amphoe Kho Wang",
        "province_id": 35
    },
    {
        "id": 3508,
        "name_th": "อำเภอเลิงนกทา",
        "name_en": "Amphoe Loeng Nok Tha",
        "province_id": 35
    },
    {
        "id": 3509,
        "name_th": "อำเภอไทยเจริญ",
        "name_en": "Amphoe Thai Charoen",
        "province_id": 35
    },
    {
        "id": 3601,
        "name_th": "อำเภอเมืองชัยภูมิ",
        "name_en": "Amphoe Mueang Chaiyaphum",
        "province_id": 36
    },
    {
        "id": 3602,
        "name_th": "อำเภอบ้านเขว้า",
        "name_en": "Amphoe Ban Khwao",
        "province_id": 36
    },
    {
        "id": 3603,
        "name_th": "อำเภอคอนสวรรค์",
        "name_en": "Amphoe Khon Sawan",
        "province_id": 36
    },
    {
        "id": 3604,
        "name_th": "อำเภอเกษตรสมบูรณ์",
        "name_en": "Amphoe Kaset Sombun",
        "province_id": 36
    },
    {
        "id": 3605,
        "name_th": "อำเภอหนองบัวแดง",
        "name_en": "Amphoe Nong Bua Daeng",
        "province_id": 36
    },
    {
        "id": 3606,
        "name_th": "อำเภอจัตุรัส",
        "name_en": "Amphoe Chatturat",
        "province_id": 36
    },
    {
        "id": 3607,
        "name_th": "อำเภอบำเหน็จณรงค์",
        "name_en": "Amphoe Bamnet Narong",
        "province_id": 36
    },
    {
        "id": 3608,
        "name_th": "อำเภอหนองบัวระเหว",
        "name_en": "Amphoe Nong Bua Rawe",
        "province_id": 36
    },
    {
        "id": 3609,
        "name_th": "อำเภอเทพสถิต",
        "name_en": "Amphoe Thep Sathit",
        "province_id": 36
    },
    {
        "id": 3610,
        "name_th": "อำเภอภูเขียว",
        "name_en": "Amphoe Phu Khiao",
        "province_id": 36
    },
    {
        "id": 3611,
        "name_th": "อำเภอบ้านแท่น",
        "name_en": "Amphoe Ban Thaen",
        "province_id": 36
    },
    {
        "id": 3612,
        "name_th": "อำเภอแก้งคร้อ",
        "name_en": "Amphoe Kaeng Khro",
        "province_id": 36
    },
    {
        "id": 3613,
        "name_th": "อำเภอคอนสาร",
        "name_en": "Amphoe Khon San",
        "province_id": 36
    },
    {
        "id": 3614,
        "name_th": "อำเภอภักดีชุมพล",
        "name_en": "Amphoe Phakdi Chumphon",
        "province_id": 36
    },
    {
        "id": 3615,
        "name_th": "อำเภอเนินสง่า",
        "name_en": "Amphoe Noen Sa-nga",
        "province_id": 36
    },
    {
        "id": 3616,
        "name_th": "อำเภอซับใหญ่",
        "name_en": "Amphoe Sap Yai",
        "province_id": 36
    },
    {
        "id": 3701,
        "name_th": "อำเภอเมืองอำนาจเจริญ",
        "name_en": "Amphoe Mueang Amnat Charoen",
        "province_id": 37
    },
    {
        "id": 3702,
        "name_th": "อำเภอชานุมาน",
        "name_en": "Amphoe Chanuman",
        "province_id": 37
    },
    {
        "id": 3703,
        "name_th": "อำเภอปทุมราชวงศา",
        "name_en": "Amphoe Pathum Ratchawongsa",
        "province_id": 37
    },
    {
        "id": 3704,
        "name_th": "อำเภอพนา",
        "name_en": "Amphoe Phana",
        "province_id": 37
    },
    {
        "id": 3705,
        "name_th": "อำเภอเสนางคนิคม",
        "name_en": "Amphoe Senangkhanikhom",
        "province_id": 37
    },
    {
        "id": 3706,
        "name_th": "อำเภอหัวตะพาน",
        "name_en": "Amphoe Hua Taphan",
        "province_id": 37
    },
    {
        "id": 3707,
        "name_th": "อำเภอลืออำนาจ",
        "name_en": "Amphoe Lue Amnat",
        "province_id": 37
    },
    {
        "id": 3801,
        "name_th": "อำเภอเมืองบึงกาฬ",
        "name_en": "Amphoe Mueang Bueng Kan",
        "province_id": 38
    },
    {
        "id": 3802,
        "name_th": "อำเภอพรเจริญ",
        "name_en": "Amphoe Phon Charoen",
        "province_id": 38
    },
    {
        "id": 3803,
        "name_th": "อำเภอโซ่พิสัย",
        "name_en": "Amphoe So Phisai",
        "province_id": 38
    },
    {
        "id": 3804,
        "name_th": "อำเภอเซกา",
        "name_en": "Amphoe Seka",
        "province_id": 38
    },
    {
        "id": 3805,
        "name_th": "อำเภอปากคาด",
        "name_en": "Amphoe Pak Khat",
        "province_id": 38
    },
    {
        "id": 3806,
        "name_th": "อำเภอบึงโขงหลง",
        "name_en": "Amphoe Bueng Khong Long",
        "province_id": 38
    },
    {
        "id": 3807,
        "name_th": "อำเภอศรีวิไล",
        "name_en": "Amphoe Si Wilai",
        "province_id": 38
    },
    {
        "id": 3808,
        "name_th": "อำเภอบุ่งคล้า",
        "name_en": "Amphoe Bung Khla",
        "province_id": 38
    },
    {
        "id": 3901,
        "name_th": "อำเภอเมืองหนองบัวลำภู",
        "name_en": "Amphoe Mueang Nong Bua Lam Phu",
        "province_id": 39
    },
    {
        "id": 3902,
        "name_th": "อำเภอนากลาง",
        "name_en": "Amphoe Na Klang",
        "province_id": 39
    },
    {
        "id": 3903,
        "name_th": "อำเภอโนนสัง",
        "name_en": "Amphoe Non Sang",
        "province_id": 39
    },
    {
        "id": 3904,
        "name_th": "อำเภอศรีบุญเรือง",
        "name_en": "Amphoe Si Bun Rueang",
        "province_id": 39
    },
    {
        "id": 3905,
        "name_th": "อำเภอสุวรรณคูหา",
        "name_en": "Amphoe Suwannakhuha",
        "province_id": 39
    },
    {
        "id": 3906,
        "name_th": "อำเภอนาวัง",
        "name_en": "Amphoe Na Wang",
        "province_id": 39
    },
    {
        "id": 4001,
        "name_th": "อำเภอเมืองขอนแก่น",
        "name_en": "Amphoe Mueang Khon Kaen",
        "province_id": 40
    },
    {
        "id": 4002,
        "name_th": "อำเภอบ้านฝาง",
        "name_en": "Amphoe Ban Fang",
        "province_id": 40
    },
    {
        "id": 4003,
        "name_th": "อำเภอพระยืน",
        "name_en": "Amphoe Phra Yuen",
        "province_id": 40
    },
    {
        "id": 4004,
        "name_th": "อำเภอหนองเรือ",
        "name_en": "Amphoe Nong Ruea",
        "province_id": 40
    },
    {
        "id": 4005,
        "name_th": "อำเภอชุมแพ",
        "name_en": "Amphoe Chum Phae",
        "province_id": 40
    },
    {
        "id": 4006,
        "name_th": "อำเภอสีชมพู",
        "name_en": "Amphoe Si Chomphu",
        "province_id": 40
    },
    {
        "id": 4007,
        "name_th": "อำเภอน้ำพอง",
        "name_en": "Amphoe Nam Phong",
        "province_id": 40
    },
    {
        "id": 4008,
        "name_th": "อำเภออุบลรัตน์",
        "name_en": "Amphoe Ubolratana",
        "province_id": 40
    },
    {
        "id": 4009,
        "name_th": "อำเภอกระนวน",
        "name_en": "Amphoe Kranuan",
        "province_id": 40
    },
    {
        "id": 4010,
        "name_th": "อำเภอบ้านไผ่",
        "name_en": "Amphoe Ban Phai",
        "province_id": 40
    },
    {
        "id": 4011,
        "name_th": "อำเภอเปือยน้อย",
        "name_en": "Amphoe Pueai Noi",
        "province_id": 40
    },
    {
        "id": 4012,
        "name_th": "อำเภอพล",
        "name_en": "Amphoe Phon",
        "province_id": 40
    },
    {
        "id": 4013,
        "name_th": "อำเภอแวงใหญ่",
        "name_en": "Amphoe Waeng Yai",
        "province_id": 40
    },
    {
        "id": 4014,
        "name_th": "อำเภอแวงน้อย",
        "name_en": "Amphoe Waeng Noi",
        "province_id": 40
    },
    {
        "id": 4015,
        "name_th": "อำเภอหนองสองห้อง",
        "name_en": "Amphoe Nong Song Hong",
        "province_id": 40
    },
    {
        "id": 4016,
        "name_th": "อำเภอภูเวียง",
        "name_en": "Amphoe Phu Wiang",
        "province_id": 40
    },
    {
        "id": 4017,
        "name_th": "อำเภอมัญจาคีรี",
        "name_en": "Amphoe Mancha Khiri",
        "province_id": 40
    },
    {
        "id": 4018,
        "name_th": "อำเภอชนบท",
        "name_en": "Amphoe Chonnabot",
        "province_id": 40
    },
    {
        "id": 4019,
        "name_th": "อำเภอเขาสวนกวาง",
        "name_en": "Amphoe Khao Suan Kwang",
        "province_id": 40
    },
    {
        "id": 4020,
        "name_th": "อำเภอภูผาม่าน",
        "name_en": "Amphoe Phu Pha Man",
        "province_id": 40
    },
    {
        "id": 4021,
        "name_th": "อำเภอซำสูง",
        "name_en": "Amphoe Sam Sung",
        "province_id": 40
    },
    {
        "id": 4022,
        "name_th": "อำเภอโคกโพธิ์ไชย",
        "name_en": "Amphoe Khok Pho Chai",
        "province_id": 40
    },
    {
        "id": 4023,
        "name_th": "อำเภอหนองนาคำ",
        "name_en": "Amphoe Nong Na Kham",
        "province_id": 40
    },
    {
        "id": 4024,
        "name_th": "อำเภอบ้านแฮด",
        "name_en": "Amphoe Ban Haet",
        "province_id": 40
    },
    {
        "id": 4025,
        "name_th": "อำเภอโนนศิลา",
        "name_en": "Amphoe Non Sila",
        "province_id": 40
    },
    {
        "id": 4029,
        "name_th": "อำเภอเวียงเก่า",
        "name_en": "Amphoe Wiang Kao",
        "province_id": 40
    },
    {
        "id": 4101,
        "name_th": "อำเภอเมืองอุดรธานี",
        "name_en": "Amphoe Mueang Udon Thani",
        "province_id": 41
    },
    {
        "id": 4102,
        "name_th": "อำเภอกุดจับ",
        "name_en": "Amphoe Kut Chap",
        "province_id": 41
    },
    {
        "id": 4103,
        "name_th": "อำเภอหนองวัวซอ",
        "name_en": "Amphoe Nong Wua So",
        "province_id": 41
    },
    {
        "id": 4104,
        "name_th": "อำเภอกุมภวาปี",
        "name_en": "Amphoe Kumphawapi",
        "province_id": 41
    },
    {
        "id": 4105,
        "name_th": "อำเภอโนนสะอาด",
        "name_en": "Amphoe Non Sa-at",
        "province_id": 41
    },
    {
        "id": 4106,
        "name_th": "อำเภอหนองหาน",
        "name_en": "Amphoe Nong Han",
        "province_id": 41
    },
    {
        "id": 4107,
        "name_th": "อำเภอทุ่งฝน",
        "name_en": "Amphoe Thung Fon",
        "province_id": 41
    },
    {
        "id": 4108,
        "name_th": "อำเภอไชยวาน",
        "name_en": "Amphoe Chai Wan",
        "province_id": 41
    },
    {
        "id": 4109,
        "name_th": "อำเภอศรีธาตุ",
        "name_en": "Amphoe Si That",
        "province_id": 41
    },
    {
        "id": 4110,
        "name_th": "อำเภอวังสามหมอ",
        "name_en": "Amphoe Wang Sam Mo",
        "province_id": 41
    },
    {
        "id": 4111,
        "name_th": "อำเภอบ้านดุง",
        "name_en": "Amphoe Ban Dung",
        "province_id": 41
    },
    {
        "id": 4117,
        "name_th": "อำเภอบ้านผือ",
        "name_en": "Amphoe Ban Phue",
        "province_id": 41
    },
    {
        "id": 4118,
        "name_th": "อำเภอน้ำโสม",
        "name_en": "Amphoe Nam Som",
        "province_id": 41
    },
    {
        "id": 4119,
        "name_th": "อำเภอเพ็ญ",
        "name_en": "Amphoe Phen",
        "province_id": 41
    },
    {
        "id": 4120,
        "name_th": "อำเภอสร้างคอม",
        "name_en": "Amphoe Sang Khom",
        "province_id": 41
    },
    {
        "id": 4121,
        "name_th": "อำเภอหนองแสง",
        "name_en": "Amphoe Nong Saeng",
        "province_id": 41
    },
    {
        "id": 4122,
        "name_th": "อำเภอนายูง",
        "name_en": "Amphoe Na Yung",
        "province_id": 41
    },
    {
        "id": 4123,
        "name_th": "อำเภอพิบูลย์รักษ์",
        "name_en": "Amphoe Phibun Rak",
        "province_id": 41
    },
    {
        "id": 4124,
        "name_th": "อำเภอกู่แก้ว",
        "name_en": "Amphoe Ku Kaeo",
        "province_id": 41
    },
    {
        "id": 4125,
        "name_th": "อำเภอประจักษ์ศิลปาคม",
        "name_en": "Amphoe Prachak Sinlapakhom",
        "province_id": 41
    },
    {
        "id": 4201,
        "name_th": "อำเภอเมืองเลย",
        "name_en": "Amphoe Mueang Loei",
        "province_id": 42
    },
    {
        "id": 4202,
        "name_th": "อำเภอนาด้วง",
        "name_en": "Amphoe Na Duang",
        "province_id": 42
    },
    {
        "id": 4203,
        "name_th": "อำเภอเชียงคาน",
        "name_en": "Amphoe Chiang Khan",
        "province_id": 42
    },
    {
        "id": 4204,
        "name_th": "อำเภอปากชม",
        "name_en": "Amphoe Pak Chom",
        "province_id": 42
    },
    {
        "id": 4205,
        "name_th": "อำเภอด่านซ้าย",
        "name_en": "Amphoe Dan Sai",
        "province_id": 42
    },
    {
        "id": 4206,
        "name_th": "อำเภอนาแห้ว",
        "name_en": "Amphoe Na Haeo",
        "province_id": 42
    },
    {
        "id": 4207,
        "name_th": "อำเภอภูเรือ",
        "name_en": "Amphoe Phu Ruea",
        "province_id": 42
    },
    {
        "id": 4208,
        "name_th": "อำเภอท่าลี่",
        "name_en": "Amphoe Tha Li",
        "province_id": 42
    },
    {
        "id": 4209,
        "name_th": "อำเภอวังสะพุง",
        "name_en": "Amphoe Wang Saphung",
        "province_id": 42
    },
    {
        "id": 4210,
        "name_th": "อำเภอภูกระดึง",
        "name_en": "Amphoe Phu Kradueng",
        "province_id": 42
    },
    {
        "id": 4211,
        "name_th": "อำเภอภูหลวง",
        "name_en": "Amphoe Phu Luang",
        "province_id": 42
    },
    {
        "id": 4212,
        "name_th": "อำเภอผาขาว",
        "name_en": "Amphoe Pha Khao",
        "province_id": 42
    },
    {
        "id": 4213,
        "name_th": "อำเภอเอราวัณ",
        "name_en": "Amphoe Erawan",
        "province_id": 42
    },
    {
        "id": 4214,
        "name_th": "อำเภอหนองหิน",
        "name_en": "Amphoe Nong Hin",
        "province_id": 42
    },
    {
        "id": 4301,
        "name_th": "อำเภอเมืองหนองคาย",
        "name_en": "Amphoe Mueang Nong Khai",
        "province_id": 43
    },
    {
        "id": 4302,
        "name_th": "อำเภอท่าบ่อ",
        "name_en": "Amphoe Tha Bo",
        "province_id": 43
    },
    {
        "id": 4305,
        "name_th": "อำเภอโพนพิสัย",
        "name_en": "Amphoe Phon Phisai",
        "province_id": 43
    },
    {
        "id": 4307,
        "name_th": "อำเภอศรีเชียงใหม่",
        "name_en": "Amphoe Si Chiang Mai",
        "province_id": 43
    },
    {
        "id": 4308,
        "name_th": "อำเภอสังคม",
        "name_en": "Amphoe Sangkhom",
        "province_id": 43
    },
    {
        "id": 4314,
        "name_th": "อำเภอสระใคร",
        "name_en": "Amphoe Sakhrai",
        "province_id": 43
    },
    {
        "id": 4315,
        "name_th": "อำเภอเฝ้าไร่",
        "name_en": "Amphoe Fao Rai",
        "province_id": 43
    },
    {
        "id": 4316,
        "name_th": "อำเภอรัตนวาปี",
        "name_en": "Amphoe Rattanawapi",
        "province_id": 43
    },
    {
        "id": 4317,
        "name_th": "อำเภอโพธิ์ตาก",
        "name_en": "Amphoe Pho Tak",
        "province_id": 43
    },
    {
        "id": 4401,
        "name_th": "อำเภอเมืองมหาสารคาม",
        "name_en": "Amphoe Mueang Maha Sarakham",
        "province_id": 44
    },
    {
        "id": 4402,
        "name_th": "อำเภอแกดำ",
        "name_en": "Amphoe Kae Dam",
        "province_id": 44
    },
    {
        "id": 4403,
        "name_th": "อำเภอโกสุมพิสัย",
        "name_en": "Amphoe Kosum Phisai",
        "province_id": 44
    },
    {
        "id": 4404,
        "name_th": "อำเภอกันทรวิชัย",
        "name_en": "Amphoe Kantharawichai",
        "province_id": 44
    },
    {
        "id": 4405,
        "name_th": "อำเภอเชียงยืน",
        "name_en": "Amphoe Chiang Yuen",
        "province_id": 44
    },
    {
        "id": 4406,
        "name_th": "อำเภอบรบือ",
        "name_en": "Amphoe Borabue",
        "province_id": 44
    },
    {
        "id": 4407,
        "name_th": "อำเภอนาเชือก",
        "name_en": "Amphoe Na Chueak",
        "province_id": 44
    },
    {
        "id": 4408,
        "name_th": "อำเภอพยัคฆภูมิพิสัย",
        "name_en": "Amphoe Phayakkhaphum Phisai",
        "province_id": 44
    },
    {
        "id": 4409,
        "name_th": "อำเภอวาปีปทุม",
        "name_en": "Amphoe Wapi Pathum",
        "province_id": 44
    },
    {
        "id": 4410,
        "name_th": "อำเภอนาดูน",
        "name_en": "Amphoe Na Dun",
        "province_id": 44
    },
    {
        "id": 4411,
        "name_th": "อำเภอยางสีสุราช",
        "name_en": "Amphoe Yang Si Surat",
        "province_id": 44
    },
    {
        "id": 4412,
        "name_th": "อำเภอกุดรัง",
        "name_en": "Amphoe Kut Rang",
        "province_id": 44
    },
    {
        "id": 4413,
        "name_th": "อำเภอชื่นชม",
        "name_en": "Amphoe Chuen Chom",
        "province_id": 44
    },
    {
        "id": 4501,
        "name_th": "อำเภอเมืองร้อยเอ็ด",
        "name_en": "Amphoe Mueang Roi Et",
        "province_id": 45
    },
    {
        "id": 4502,
        "name_th": "อำเภอเกษตรวิสัย",
        "name_en": "Amphoe Kaset Wisai",
        "province_id": 45
    },
    {
        "id": 4503,
        "name_th": "อำเภอปทุมรัตต์",
        "name_en": "Amphoe Pathum Rat",
        "province_id": 45
    },
    {
        "id": 4504,
        "name_th": "อำเภอจตุรพักตรพิมาน",
        "name_en": "Amphoe Chaturaphak Phiman",
        "province_id": 45
    },
    {
        "id": 4505,
        "name_th": "อำเภอธวัชบุรี",
        "name_en": "Amphoe Thawat Buri",
        "province_id": 45
    },
    {
        "id": 4506,
        "name_th": "อำเภอพนมไพร",
        "name_en": "Amphoe Phanom Phrai",
        "province_id": 45
    },
    {
        "id": 4507,
        "name_th": "อำเภอโพนทอง",
        "name_en": "Amphoe Phon Thong",
        "province_id": 45
    },
    {
        "id": 4508,
        "name_th": "อำเภอโพธิ์ชัย",
        "name_en": "Amphoe Pho Chai",
        "province_id": 45
    },
    {
        "id": 4509,
        "name_th": "อำเภอหนองพอก",
        "name_en": "Amphoe Nong Phok",
        "province_id": 45
    },
    {
        "id": 4510,
        "name_th": "อำเภอเสลภูมิ",
        "name_en": "Amphoe Selaphum",
        "province_id": 45
    },
    {
        "id": 4511,
        "name_th": "อำเภอสุวรรณภูมิ",
        "name_en": "Amphoe Suwannaphum",
        "province_id": 45
    },
    {
        "id": 4512,
        "name_th": "อำเภอเมืองสรวง",
        "name_en": "Amphoe Mueang Suang",
        "province_id": 45
    },
    {
        "id": 4513,
        "name_th": "อำเภอโพนทราย",
        "name_en": "Amphoe Phon Sai",
        "province_id": 45
    },
    {
        "id": 4514,
        "name_th": "อำเภออาจสามารถ",
        "name_en": "Amphoe At Samat",
        "province_id": 45
    },
    {
        "id": 4515,
        "name_th": "อำเภอเมยวดี",
        "name_en": "Amphoe Moei Wadi",
        "province_id": 45
    },
    {
        "id": 4516,
        "name_th": "อำเภอศรีสมเด็จ",
        "name_en": "Amphoe Si Somdet",
        "province_id": 45
    },
    {
        "id": 4517,
        "name_th": "อำเภอจังหาร",
        "name_en": "Amphoe Changhan",
        "province_id": 45
    },
    {
        "id": 4518,
        "name_th": "อำเภอเชียงขวัญ",
        "name_en": "Amphoe Chiang Khwan",
        "province_id": 45
    },
    {
        "id": 4519,
        "name_th": "อำเภอหนองฮี",
        "name_en": "Amphoe Nong Hi",
        "province_id": 45
    },
    {
        "id": 4520,
        "name_th": "อำเภอทุ่งเขาหลวง",
        "name_en": "Amphoe Thung Khao Luang",
        "province_id": 45
    },
    {
        "id": 4601,
        "name_th": "อำเภอเมืองกาฬสินธุ์",
        "name_en": "Amphoe Mueang Kalasin",
        "province_id": 46
    },
    {
        "id": 4602,
        "name_th": "อำเภอนามน",
        "name_en": "Amphoe Na Mon",
        "province_id": 46
    },
    {
        "id": 4603,
        "name_th": "อำเภอกมลาไสย",
        "name_en": "Amphoe Kamalasai",
        "province_id": 46
    },
    {
        "id": 4604,
        "name_th": "อำเภอร่องคำ",
        "name_en": "Amphoe Rong Kham",
        "province_id": 46
    },
    {
        "id": 4605,
        "name_th": "อำเภอกุฉินารายณ์",
        "name_en": "Amphoe Kuchinarai",
        "province_id": 46
    },
    {
        "id": 4606,
        "name_th": "อำเภอเขาวง",
        "name_en": "Amphoe Khao Wong",
        "province_id": 46
    },
    {
        "id": 4607,
        "name_th": "อำเภอยางตลาด",
        "name_en": "Amphoe Yang Talat",
        "province_id": 46
    },
    {
        "id": 4608,
        "name_th": "อำเภอห้วยเม็ก",
        "name_en": "Amphoe Huai Mek",
        "province_id": 46
    },
    {
        "id": 4609,
        "name_th": "อำเภอสหัสขันธ์",
        "name_en": "Amphoe Sahatsakhan",
        "province_id": 46
    },
    {
        "id": 4610,
        "name_th": "อำเภอคำม่วง",
        "name_en": "Amphoe Kham Muang",
        "province_id": 46
    },
    {
        "id": 4611,
        "name_th": "อำเภอท่าคันโท",
        "name_en": "Amphoe Tha Khantho",
        "province_id": 46
    },
    {
        "id": 4612,
        "name_th": "อำเภอหนองกุงศรี",
        "name_en": "Amphoe Nong Kung Si",
        "province_id": 46
    },
    {
        "id": 4613,
        "name_th": "อำเภอสมเด็จ",
        "name_en": "Amphoe Somdet",
        "province_id": 46
    },
    {
        "id": 4614,
        "name_th": "อำเภอห้วยผึ้ง",
        "name_en": "Amphoe Huai Phueng",
        "province_id": 46
    },
    {
        "id": 4615,
        "name_th": "อำเภอสามชัย",
        "name_en": "Amphoe Sam Chai",
        "province_id": 46
    },
    {
        "id": 4616,
        "name_th": "อำเภอนาคู",
        "name_en": "Amphoe Na Khu",
        "province_id": 46
    },
    {
        "id": 4617,
        "name_th": "อำเภอดอนจาน",
        "name_en": "Amphoe Don Chan",
        "province_id": 46
    },
    {
        "id": 4618,
        "name_th": "อำเภอฆ้องชัย",
        "name_en": "Amphoe Khong Chai",
        "province_id": 46
    },
    {
        "id": 4701,
        "name_th": "อำเภอเมืองสกลนคร",
        "name_en": "Amphoe Mueang Sakon Nakhon",
        "province_id": 47
    },
    {
        "id": 4702,
        "name_th": "อำเภอกุสุมาลย์",
        "name_en": "Amphoe Kusuman",
        "province_id": 47
    },
    {
        "id": 4703,
        "name_th": "อำเภอกุดบาก",
        "name_en": "Amphoe Kut Bak",
        "province_id": 47
    },
    {
        "id": 4704,
        "name_th": "อำเภอพรรณานิคม",
        "name_en": "Amphoe Phanna Nikhom",
        "province_id": 47
    },
    {
        "id": 4705,
        "name_th": "อำเภอพังโคน",
        "name_en": "Amphoe Phang Khon",
        "province_id": 47
    },
    {
        "id": 4706,
        "name_th": "อำเภอวาริชภูมิ",
        "name_en": "Amphoe Waritchaphum",
        "province_id": 47
    },
    {
        "id": 4707,
        "name_th": "อำเภอนิคมน้ำอูน",
        "name_en": "Amphoe Nikhom Nam Un",
        "province_id": 47
    },
    {
        "id": 4708,
        "name_th": "อำเภอวานรนิวาส",
        "name_en": "Amphoe Wanon Niwat",
        "province_id": 47
    },
    {
        "id": 4709,
        "name_th": "อำเภอคำตากล้า",
        "name_en": "Amphoe Kham Ta Kla",
        "province_id": 47
    },
    {
        "id": 4710,
        "name_th": "อำเภอบ้านม่วง",
        "name_en": "Amphoe Ban Muang",
        "province_id": 47
    },
    {
        "id": 4711,
        "name_th": "อำเภออากาศอำนวย",
        "name_en": "Amphoe Akat Amnuai",
        "province_id": 47
    },
    {
        "id": 4712,
        "name_th": "อำเภอสว่างแดนดิน",
        "name_en": "Amphoe Sawang Daen Din",
        "province_id": 47
    },
    {
        "id": 4713,
        "name_th": "อำเภอส่องดาว",
        "name_en": "Amphoe Song Dao",
        "province_id": 47
    },
    {
        "id": 4714,
        "name_th": "อำเภอเต่างอย",
        "name_en": "Amphoe Tao Ngoi",
        "province_id": 47
    },
    {
        "id": 4715,
        "name_th": "อำเภอโคกศรีสุพรรณ",
        "name_en": "Amphoe Khok Si Suphan",
        "province_id": 47
    },
    {
        "id": 4716,
        "name_th": "อำเภอเจริญศิลป์",
        "name_en": "Amphoe Charoen Sin",
        "province_id": 47
    },
    {
        "id": 4717,
        "name_th": "อำเภอโพนนาแก้ว",
        "name_en": "Amphoe Phon Na Kaeo",
        "province_id": 47
    },
    {
        "id": 4718,
        "name_th": "อำเภอภูพาน",
        "name_en": "Amphoe Phu Phan",
        "province_id": 47
    },
    {
        "id": 4801,
        "name_th": "อำเภอเมืองนครพนม",
        "name_en": "Amphoe Mueang Nakhon Phanom",
        "province_id": 48
    },
    {
        "id": 4802,
        "name_th": "อำเภอปลาปาก",
        "name_en": "Amphoe Pla Pak",
        "province_id": 48
    },
    {
        "id": 4803,
        "name_th": "อำเภอท่าอุเทน",
        "name_en": "Amphoe Tha Uthen",
        "province_id": 48
    },
    {
        "id": 4804,
        "name_th": "อำเภอบ้านแพง",
        "name_en": "Amphoe Ban Phaeng",
        "province_id": 48
    },
    {
        "id": 4805,
        "name_th": "อำเภอธาตุพนม",
        "name_en": "Amphoe That Phanom",
        "province_id": 48
    },
    {
        "id": 4806,
        "name_th": "อำเภอเรณูนคร",
        "name_en": "Amphoe Renu Nakhon",
        "province_id": 48
    },
    {
        "id": 4807,
        "name_th": "อำเภอนาแก",
        "name_en": "Amphoe Na Kae",
        "province_id": 48
    },
    {
        "id": 4808,
        "name_th": "อำเภอศรีสงคราม",
        "name_en": "Amphoe Si Songkhram",
        "province_id": 48
    },
    {
        "id": 4809,
        "name_th": "อำเภอนาหว้า",
        "name_en": "Amphoe Na Wa",
        "province_id": 48
    },
    {
        "id": 4810,
        "name_th": "อำเภอโพนสวรรค์",
        "name_en": "Amphoe Phon Sawan",
        "province_id": 48
    },
    {
        "id": 4811,
        "name_th": "อำเภอนาทม",
        "name_en": "Amphoe Na Thom",
        "province_id": 48
    },
    {
        "id": 4812,
        "name_th": "อำเภอวังยาง",
        "name_en": "Amphoe Wang Yang",
        "province_id": 48
    },
    {
        "id": 4901,
        "name_th": "อำเภอเมืองมุกดาหาร",
        "name_en": "Amphoe Mueang Mukdahan",
        "province_id": 49
    },
    {
        "id": 4902,
        "name_th": "อำเภอนิคมคำสร้อย",
        "name_en": "Amphoe Nikhom Kham Soi",
        "province_id": 49
    },
    {
        "id": 4903,
        "name_th": "อำเภอดอนตาล",
        "name_en": "Amphoe Don Tan",
        "province_id": 49
    },
    {
        "id": 4904,
        "name_th": "อำเภอดงหลวง",
        "name_en": "Amphoe Dong Luang",
        "province_id": 49
    },
    {
        "id": 4905,
        "name_th": "อำเภอคำชะอี",
        "name_en": "Amphoe Khamcha-i",
        "province_id": 49
    },
    {
        "id": 4906,
        "name_th": "อำเภอหว้านใหญ่",
        "name_en": "Amphoe Wan Yai",
        "province_id": 49
    },
    {
        "id": 4907,
        "name_th": "อำเภอหนองสูง",
        "name_en": "Amphoe Nong Sung",
        "province_id": 49
    },
    {
        "id": 5001,
        "name_th": "อำเภอเมืองเชียงใหม่",
        "name_en": "Amphoe Mueang Chiang Mai",
        "province_id": 50
    },
    {
        "id": 5002,
        "name_th": "อำเภอจอมทอง",
        "name_en": "Amphoe Chom Thong",
        "province_id": 50
    },
    {
        "id": 5003,
        "name_th": "อำเภอแม่แจ่ม",
        "name_en": "Amphoe Mae Chaem",
        "province_id": 50
    },
    {
        "id": 5004,
        "name_th": "อำเภอเชียงดาว",
        "name_en": "Amphoe Chiang Dao",
        "province_id": 50
    },
    {
        "id": 5005,
        "name_th": "อำเภอดอยสะเก็ด",
        "name_en": "Amphoe Doi Saket",
        "province_id": 50
    },
    {
        "id": 5006,
        "name_th": "อำเภอแม่แตง",
        "name_en": "Amphoe Mae Taeng",
        "province_id": 50
    },
    {
        "id": 5007,
        "name_th": "อำเภอแม่ริม",
        "name_en": "Amphoe Mae Rim",
        "province_id": 50
    },
    {
        "id": 5008,
        "name_th": "อำเภอสะเมิง",
        "name_en": "Amphoe Samoeng",
        "province_id": 50
    },
    {
        "id": 5009,
        "name_th": "อำเภอฝาง",
        "name_en": "Amphoe Fang",
        "province_id": 50
    },
    {
        "id": 5010,
        "name_th": "อำเภอแม่อาย",
        "name_en": "Amphoe Mae Ai",
        "province_id": 50
    },
    {
        "id": 5011,
        "name_th": "อำเภอพร้าว",
        "name_en": "Amphoe Phrao",
        "province_id": 50
    },
    {
        "id": 5012,
        "name_th": "อำเภอสันป่าตอง",
        "name_en": "Amphoe San Pa Tong",
        "province_id": 50
    },
    {
        "id": 5013,
        "name_th": "อำเภอสันกำแพง",
        "name_en": "Amphoe San Kamphaeng",
        "province_id": 50
    },
    {
        "id": 5014,
        "name_th": "อำเภอสันทราย",
        "name_en": "Amphoe San Sai",
        "province_id": 50
    },
    {
        "id": 5015,
        "name_th": "อำเภอหางดง",
        "name_en": "Amphoe Hang Dong",
        "province_id": 50
    },
    {
        "id": 5016,
        "name_th": "อำเภอฮอด",
        "name_en": "Amphoe Hot",
        "province_id": 50
    },
    {
        "id": 5017,
        "name_th": "อำเภอดอยเต่า",
        "name_en": "Amphoe Doi Tao",
        "province_id": 50
    },
    {
        "id": 5018,
        "name_th": "อำเภออมก๋อย",
        "name_en": "Amphoe Omkoi",
        "province_id": 50
    },
    {
        "id": 5019,
        "name_th": "อำเภอสารภี",
        "name_en": "Amphoe Saraphi",
        "province_id": 50
    },
    {
        "id": 5020,
        "name_th": "อำเภอเวียงแหง",
        "name_en": "Amphoe Wiang Haeng",
        "province_id": 50
    },
    {
        "id": 5021,
        "name_th": "อำเภอไชยปราการ",
        "name_en": "Amphoe Chai Prakan",
        "province_id": 50
    },
    {
        "id": 5022,
        "name_th": "อำเภอแม่วาง",
        "name_en": "Amphoe Mae Wang",
        "province_id": 50
    },
    {
        "id": 5023,
        "name_th": "อำเภอแม่ออน",
        "name_en": "Amphoe Mae On",
        "province_id": 50
    },
    {
        "id": 5024,
        "name_th": "อำเภอดอยหล่อ",
        "name_en": "Amphoe Doi Lo",
        "province_id": 50
    },
    {
        "id": 5025,
        "name_th": "อำเภอกัลยาณิวัฒนา",
        "name_en": "Amphoe Galayani Vadhana",
        "province_id": 50
    },
    {
        "id": 5101,
        "name_th": "อำเภอเมืองลำพูน",
        "name_en": "Amphoe Mueang Lamphun",
        "province_id": 51
    },
    {
        "id": 5102,
        "name_th": "อำเภอแม่ทา",
        "name_en": "Amphoe Mae Tha",
        "province_id": 51
    },
    {
        "id": 5103,
        "name_th": "อำเภอบ้านโฮ่ง",
        "name_en": "Amphoe Ban Hong",
        "province_id": 51
    },
    {
        "id": 5104,
        "name_th": "อำเภอลี้",
        "name_en": "Amphoe Li",
        "province_id": 51
    },
    {
        "id": 5105,
        "name_th": "อำเภอทุ่งหัวช้าง",
        "name_en": "Amphoe Thung Hua Chang",
        "province_id": 51
    },
    {
        "id": 5106,
        "name_th": "อำเภอป่าซาง",
        "name_en": "Amphoe Pa Sang",
        "province_id": 51
    },
    {
        "id": 5107,
        "name_th": "อำเภอบ้านธิ",
        "name_en": "Amphoe Ban Thi",
        "province_id": 51
    },
    {
        "id": 5108,
        "name_th": "อำเภอเวียงหนองล่อง",
        "name_en": "Amphoe Wiang Nong Long",
        "province_id": 51
    },
    {
        "id": 5201,
        "name_th": "อำเภอเมืองลำปาง",
        "name_en": "Amphoe Mueang Lampang",
        "province_id": 52
    },
    {
        "id": 5202,
        "name_th": "อำเภอแม่เมาะ",
        "name_en": "Amphoe Mae Mo",
        "province_id": 52
    },
    {
        "id": 5203,
        "name_th": "อำเภอเกาะคา",
        "name_en": "Amphoe Ko Kha",
        "province_id": 52
    },
    {
        "id": 5204,
        "name_th": "อำเภอเสริมงาม",
        "name_en": "Amphoe Soem Ngam",
        "province_id": 52
    },
    {
        "id": 5205,
        "name_th": "อำเภองาว",
        "name_en": "Amphoe Ngao",
        "province_id": 52
    },
    {
        "id": 5206,
        "name_th": "อำเภอแจ้ห่ม",
        "name_en": "Amphoe Chae Hom",
        "province_id": 52
    },
    {
        "id": 5207,
        "name_th": "อำเภอวังเหนือ",
        "name_en": "Amphoe Wang Nuea",
        "province_id": 52
    },
    {
        "id": 5208,
        "name_th": "อำเภอเถิน",
        "name_en": "Amphoe Thoen",
        "province_id": 52
    },
    {
        "id": 5209,
        "name_th": "อำเภอแม่พริก",
        "name_en": "Amphoe Mae Phrik",
        "province_id": 52
    },
    {
        "id": 5210,
        "name_th": "อำเภอแม่ทะ",
        "name_en": "Amphoe Mae Tha",
        "province_id": 52
    },
    {
        "id": 5211,
        "name_th": "อำเภอสบปราบ",
        "name_en": "Amphoe Sop Prap",
        "province_id": 52
    },
    {
        "id": 5212,
        "name_th": "อำเภอห้างฉัตร",
        "name_en": "Amphoe Hang Chat",
        "province_id": 52
    },
    {
        "id": 5213,
        "name_th": "อำเภอเมืองปาน",
        "name_en": "Amphoe Mueang Pan",
        "province_id": 52
    },
    {
        "id": 5301,
        "name_th": "อำเภอเมืองอุตรดิตถ์",
        "name_en": "Amphoe Mueang Uttaradit",
        "province_id": 53
    },
    {
        "id": 5302,
        "name_th": "อำเภอตรอน",
        "name_en": "Amphoe Tron",
        "province_id": 53
    },
    {
        "id": 5303,
        "name_th": "อำเภอท่าปลา",
        "name_en": "Amphoe Tha Pla",
        "province_id": 53
    },
    {
        "id": 5304,
        "name_th": "อำเภอน้ำปาด",
        "name_en": "Amphoe Nam Pat",
        "province_id": 53
    },
    {
        "id": 5305,
        "name_th": "อำเภอฟากท่า",
        "name_en": "Amphoe Fak Tha",
        "province_id": 53
    },
    {
        "id": 5306,
        "name_th": "อำเภอบ้านโคก",
        "name_en": "Amphoe Ban Khok",
        "province_id": 53
    },
    {
        "id": 5307,
        "name_th": "อำเภอพิชัย",
        "name_en": "Amphoe Phichai",
        "province_id": 53
    },
    {
        "id": 5308,
        "name_th": "อำเภอลับแล",
        "name_en": "Amphoe Laplae",
        "province_id": 53
    },
    {
        "id": 5309,
        "name_th": "อำเภอทองแสนขัน",
        "name_en": "Amphoe Thong Saen Khan",
        "province_id": 53
    },
    {
        "id": 5401,
        "name_th": "อำเภอเมืองแพร่",
        "name_en": "Amphoe Mueang Phrae",
        "province_id": 54
    },
    {
        "id": 5402,
        "name_th": "อำเภอร้องกวาง",
        "name_en": "Amphoe Rong Kwang",
        "province_id": 54
    },
    {
        "id": 5403,
        "name_th": "อำเภอลอง",
        "name_en": "Amphoe Long",
        "province_id": 54
    },
    {
        "id": 5404,
        "name_th": "อำเภอสูงเม่น",
        "name_en": "Amphoe Sung Men",
        "province_id": 54
    },
    {
        "id": 5405,
        "name_th": "อำเภอเด่นชัย",
        "name_en": "Amphoe Den Chai",
        "province_id": 54
    },
    {
        "id": 5406,
        "name_th": "อำเภอสอง",
        "name_en": "Amphoe Song",
        "province_id": 54
    },
    {
        "id": 5407,
        "name_th": "อำเภอวังชิ้น",
        "name_en": "Amphoe Wang Chin",
        "province_id": 54
    },
    {
        "id": 5408,
        "name_th": "อำเภอหนองม่วงไข่",
        "name_en": "Amphoe Nong Muang Khai",
        "province_id": 54
    },
    {
        "id": 5501,
        "name_th": "อำเภอเมืองน่าน",
        "name_en": "Amphoe Mueang Nan",
        "province_id": 55
    },
    {
        "id": 5502,
        "name_th": "อำเภอแม่จริม",
        "name_en": "Amphoe Mae Charim",
        "province_id": 55
    },
    {
        "id": 5503,
        "name_th": "อำเภอบ้านหลวง",
        "name_en": "Amphoe Ban Luang",
        "province_id": 55
    },
    {
        "id": 5504,
        "name_th": "อำเภอนาน้อย",
        "name_en": "Amphoe Na Noi",
        "province_id": 55
    },
    {
        "id": 5505,
        "name_th": "อำเภอปัว",
        "name_en": "Amphoe Pua",
        "province_id": 55
    },
    {
        "id": 5506,
        "name_th": "อำเภอท่าวังผา",
        "name_en": "Amphoe Tha Wang Pha",
        "province_id": 55
    },
    {
        "id": 5507,
        "name_th": "อำเภอเวียงสา",
        "name_en": "Amphoe Wiang Sa",
        "province_id": 55
    },
    {
        "id": 5508,
        "name_th": "อำเภอทุ่งช้าง",
        "name_en": "Amphoe Thung Chang",
        "province_id": 55
    },
    {
        "id": 5509,
        "name_th": "อำเภอเชียงกลาง",
        "name_en": "Amphoe Chiang Klang",
        "province_id": 55
    },
    {
        "id": 5510,
        "name_th": "อำเภอนาหมื่น",
        "name_en": "Amphoe Na Muen",
        "province_id": 55
    },
    {
        "id": 5511,
        "name_th": "อำเภอสันติสุข",
        "name_en": "Amphoe Santi Suk",
        "province_id": 55
    },
    {
        "id": 5512,
        "name_th": "อำเภอบ่อเกลือ",
        "name_en": "Amphoe Bo Kluea",
        "province_id": 55
    },
    {
        "id": 5513,
        "name_th": "อำเภอสองแคว",
        "name_en": "Amphoe Song Khwae",
        "province_id": 55
    },
    {
        "id": 5514,
        "name_th": "อำเภอภูเพียง",
        "name_en": "Amphoe Phu Phiang",
        "province_id": 55
    },
    {
        "id": 5515,
        "name_th": "อำเภอเฉลิมพระเกียรติ",
        "name_en": "Amphoe Chaloem Phra Kiat",
        "province_id": 55
    },
    {
        "id": 5601,
        "name_th": "อำเภอเมืองพะเยา",
        "name_en": "Amphoe Mueang Phayao",
        "province_id": 56
    },
    {
        "id": 5602,
        "name_th": "อำเภอจุน",
        "name_en": "Amphoe Chun",
        "province_id": 56
    },
    {
        "id": 5603,
        "name_th": "อำเภอเชียงคำ",
        "name_en": "Amphoe Chiang Kham",
        "province_id": 56
    },
    {
        "id": 5604,
        "name_th": "อำเภอเชียงม่วน",
        "name_en": "Amphoe Chiang Muan",
        "province_id": 56
    },
    {
        "id": 5605,
        "name_th": "อำเภอดอกคำใต้",
        "name_en": "Amphoe Dok Khamtai",
        "province_id": 56
    },
    {
        "id": 5606,
        "name_th": "อำเภอปง",
        "name_en": "Amphoe Pong",
        "province_id": 56
    },
    {
        "id": 5607,
        "name_th": "อำเภอแม่ใจ",
        "name_en": "Amphoe Mae Chai",
        "province_id": 56
    },
    {
        "id": 5608,
        "name_th": "อำเภอภูซาง",
        "name_en": "Amphoe Phu Sang",
        "province_id": 56
    },
    {
        "id": 5609,
        "name_th": "อำเภอภูกามยาว",
        "name_en": "Amphoe Phu Kamyao",
        "province_id": 56
    },
    {
        "id": 5701,
        "name_th": "อำเภอเมืองเชียงราย",
        "name_en": "Amphoe Mueang Chiang Rai",
        "province_id": 57
    },
    {
        "id": 5702,
        "name_th": "อำเภอเวียงชัย",
        "name_en": "Amphoe Wiang Chai",
        "province_id": 57
    },
    {
        "id": 5703,
        "name_th": "อำเภอเชียงของ",
        "name_en": "Amphoe Chiang Khong",
        "province_id": 57
    },
    {
        "id": 5704,
        "name_th": "อำเภอเทิง",
        "name_en": "Amphoe Thoeng",
        "province_id": 57
    },
    {
        "id": 5705,
        "name_th": "อำเภอพาน",
        "name_en": "Amphoe Phan",
        "province_id": 57
    },
    {
        "id": 5706,
        "name_th": "อำเภอป่าแดด",
        "name_en": "Amphoe Pa Daet",
        "province_id": 57
    },
    {
        "id": 5707,
        "name_th": "อำเภอแม่จัน",
        "name_en": "Amphoe Mae Chan",
        "province_id": 57
    },
    {
        "id": 5708,
        "name_th": "อำเภอเชียงแสน",
        "name_en": "Amphoe Chiang Saen",
        "province_id": 57
    },
    {
        "id": 5709,
        "name_th": "อำเภอแม่สาย",
        "name_en": "Amphoe Mae Sai",
        "province_id": 57
    },
    {
        "id": 5710,
        "name_th": "อำเภอแม่สรวย",
        "name_en": "Amphoe Mae Suai",
        "province_id": 57
    },
    {
        "id": 5711,
        "name_th": "อำเภอเวียงป่าเป้า",
        "name_en": "Amphoe Wiang Pa Pao",
        "province_id": 57
    },
    {
        "id": 5712,
        "name_th": "อำเภอพญาเม็งราย",
        "name_en": "Amphoe Phaya Mengrai",
        "province_id": 57
    },
    {
        "id": 5713,
        "name_th": "อำเภอเวียงแก่น",
        "name_en": "Amphoe Wiang Kaen",
        "province_id": 57
    },
    {
        "id": 5714,
        "name_th": "อำเภอขุนตาล",
        "name_en": "Amphoe Khun Tan",
        "province_id": 57
    },
    {
        "id": 5715,
        "name_th": "อำเภอแม่ฟ้าหลวง",
        "name_en": "Amphoe Mae Fa Luang",
        "province_id": 57
    },
    {
        "id": 5716,
        "name_th": "อำเภอแม่ลาว",
        "name_en": "Amphoe Mae Lao",
        "province_id": 57
    },
    {
        "id": 5717,
        "name_th": "อำเภอเวียงเชียงรุ้ง",
        "name_en": "Amphoe Wiang Chiang Rung",
        "province_id": 57
    },
    {
        "id": 5718,
        "name_th": "อำเภอดอยหลวง",
        "name_en": "Amphoe Doi Luang",
        "province_id": 57
    },
    {
        "id": 5801,
        "name_th": "อำเภอเมืองแม่ฮ่องสอน",
        "name_en": "Amphoe Mueang Mae Hong Son",
        "province_id": 58
    },
    {
        "id": 5802,
        "name_th": "อำเภอขุนยวม",
        "name_en": "Amphoe Khun Yuam",
        "province_id": 58
    },
    {
        "id": 5803,
        "name_th": "อำเภอปาย",
        "name_en": "Amphoe Pai",
        "province_id": 58
    },
    {
        "id": 5804,
        "name_th": "อำเภอแม่สะเรียง",
        "name_en": "Amphoe Mae Sariang",
        "province_id": 58
    },
    {
        "id": 5805,
        "name_th": "อำเภอแม่ลาน้อย",
        "name_en": "Amphoe Mae La Noi",
        "province_id": 58
    },
    {
        "id": 5806,
        "name_th": "อำเภอสบเมย",
        "name_en": "Amphoe Sop Moei",
        "province_id": 58
    },
    {
        "id": 5807,
        "name_th": "อำเภอปางมะผ้า",
        "name_en": "Amphoe Pang Mapha",
        "province_id": 58
    },
    {
        "id": 6001,
        "name_th": "อำเภอเมืองนครสวรรค์",
        "name_en": "Amphoe Mueang Nakhon Sawan",
        "province_id": 60
    },
    {
        "id": 6002,
        "name_th": "อำเภอโกรกพระ",
        "name_en": "Amphoe Krok Phra",
        "province_id": 60
    },
    {
        "id": 6003,
        "name_th": "อำเภอชุมแสง",
        "name_en": "Amphoe Chum Saeng",
        "province_id": 60
    },
    {
        "id": 6004,
        "name_th": "อำเภอหนองบัว",
        "name_en": "Amphoe Nong Bua",
        "province_id": 60
    },
    {
        "id": 6005,
        "name_th": "อำเภอบรรพตพิสัย",
        "name_en": "Amphoe Banphot Phisai",
        "province_id": 60
    },
    {
        "id": 6006,
        "name_th": "อำเภอเก้าเลี้ยว",
        "name_en": "Amphoe Kao Liao",
        "province_id": 60
    },
    {
        "id": 6007,
        "name_th": "อำเภอตาคลี",
        "name_en": "Amphoe Takhli",
        "province_id": 60
    },
    {
        "id": 6008,
        "name_th": "อำเภอท่าตะโก",
        "name_en": "Amphoe Tha Tako",
        "province_id": 60
    },
    {
        "id": 6009,
        "name_th": "อำเภอไพศาลี",
        "name_en": "Amphoe Phaisali",
        "province_id": 60
    },
    {
        "id": 6010,
        "name_th": "อำเภอพยุหะคีรี",
        "name_en": "Amphoe Phayuha Khiri",
        "province_id": 60
    },
    {
        "id": 6011,
        "name_th": "อำเภอลาดยาว",
        "name_en": "Amphoe Lat Yao",
        "province_id": 60
    },
    {
        "id": 6012,
        "name_th": "อำเภอตากฟ้า",
        "name_en": "Amphoe Tak Fa",
        "province_id": 60
    },
    {
        "id": 6013,
        "name_th": "อำเภอแม่วงก์",
        "name_en": "Amphoe Mae Wong",
        "province_id": 60
    },
    {
        "id": 6014,
        "name_th": "อำเภอแม่เปิน",
        "name_en": "Amphoe Mae Poen",
        "province_id": 60
    },
    {
        "id": 6015,
        "name_th": "อำเภอชุมตาบง",
        "name_en": "Amphoe Chum Ta Bong",
        "province_id": 60
    },
    {
        "id": 6101,
        "name_th": "อำเภอเมืองอุทัยธานี",
        "name_en": "Amphoe Mueang Uthai Thani",
        "province_id": 61
    },
    {
        "id": 6102,
        "name_th": "อำเภอทัพทัน",
        "name_en": "Amphoe Thap Than",
        "province_id": 61
    },
    {
        "id": 6103,
        "name_th": "อำเภอสว่างอารมณ์",
        "name_en": "Amphoe Sawang Arom",
        "province_id": 61
    },
    {
        "id": 6104,
        "name_th": "อำเภอหนองฉาง",
        "name_en": "Amphoe Nong Chang",
        "province_id": 61
    },
    {
        "id": 6105,
        "name_th": "อำเภอหนองขาหย่าง",
        "name_en": "Amphoe Nong Khayang",
        "province_id": 61
    },
    {
        "id": 6106,
        "name_th": "อำเภอบ้านไร่",
        "name_en": "Amphoe Ban Rai",
        "province_id": 61
    },
    {
        "id": 6107,
        "name_th": "อำเภอลานสัก",
        "name_en": "Amphoe Lan Sak",
        "province_id": 61
    },
    {
        "id": 6108,
        "name_th": "อำเภอห้วยคต",
        "name_en": "Amphoe Huai Khot",
        "province_id": 61
    },
    {
        "id": 6201,
        "name_th": "อำเภอเมืองกำแพงเพชร",
        "name_en": "Amphoe Mueang Kamphaeng Phet",
        "province_id": 62
    },
    {
        "id": 6202,
        "name_th": "อำเภอไทรงาม",
        "name_en": "Amphoe Sai Ngam",
        "province_id": 62
    },
    {
        "id": 6203,
        "name_th": "อำเภอคลองลาน",
        "name_en": "Amphoe Khlong Lan",
        "province_id": 62
    },
    {
        "id": 6204,
        "name_th": "อำเภอขาณุวรลักษบุรี",
        "name_en": "Amphoe Khanu Woralaksaburi",
        "province_id": 62
    },
    {
        "id": 6205,
        "name_th": "อำเภอคลองขลุง",
        "name_en": "Amphoe Khlong Khlung",
        "province_id": 62
    },
    {
        "id": 6206,
        "name_th": "อำเภอพรานกระต่าย",
        "name_en": "Amphoe Phran Kratai",
        "province_id": 62
    },
    {
        "id": 6207,
        "name_th": "อำเภอลานกระบือ",
        "name_en": "Amphoe Lan Krabue",
        "province_id": 62
    },
    {
        "id": 6208,
        "name_th": "อำเภอทรายทองวัฒนา",
        "name_en": "Amphoe Sai Thong Watthana",
        "province_id": 62
    },
    {
        "id": 6209,
        "name_th": "อำเภอปางศิลาทอง",
        "name_en": "Amphoe Pang Sila Thong",
        "province_id": 62
    },
    {
        "id": 6210,
        "name_th": "อำเภอบึงสามัคคี",
        "name_en": "Amphoe Bueng Samakkhi",
        "province_id": 62
    },
    {
        "id": 6211,
        "name_th": "อำเภอโกสัมพีนคร",
        "name_en": "Amphoe Kosamphi Nakhon",
        "province_id": 62
    },
    {
        "id": 6301,
        "name_th": "อำเภอเมืองตาก",
        "name_en": "Amphoe Mueang Tak",
        "province_id": 63
    },
    {
        "id": 6302,
        "name_th": "อำเภอบ้านตาก",
        "name_en": "Amphoe Ban Tak",
        "province_id": 63
    },
    {
        "id": 6303,
        "name_th": "อำเภอสามเงา",
        "name_en": "Amphoe Sam Ngao",
        "province_id": 63
    },
    {
        "id": 6304,
        "name_th": "อำเภอแม่ระมาด",
        "name_en": "Amphoe Mae Ramat",
        "province_id": 63
    },
    {
        "id": 6305,
        "name_th": "อำเภอท่าสองยาง",
        "name_en": "Amphoe Tha Song Yang",
        "province_id": 63
    },
    {
        "id": 6306,
        "name_th": "อำเภอแม่สอด",
        "name_en": "Amphoe Mae Sot",
        "province_id": 63
    },
    {
        "id": 6307,
        "name_th": "อำเภอพบพระ",
        "name_en": "Amphoe Phop Phra",
        "province_id": 63
    },
    {
        "id": 6308,
        "name_th": "อำเภออุ้มผาง",
        "name_en": "Amphoe Umphang",
        "province_id": 63
    },
    {
        "id": 6309,
        "name_th": "อำเภอวังเจ้า",
        "name_en": "Amphoe Wang Chao",
        "province_id": 63
    },
    {
        "id": 6401,
        "name_th": "อำเภอเมืองสุโขทัย",
        "name_en": "Amphoe Mueang Sukhothai",
        "province_id": 64
    },
    {
        "id": 6402,
        "name_th": "อำเภอบ้านด่านลานหอย",
        "name_en": "Amphoe Ban Dan Lan Hoi",
        "province_id": 64
    },
    {
        "id": 6403,
        "name_th": "อำเภอคีรีมาศ",
        "name_en": "Amphoe Khiri Mat",
        "province_id": 64
    },
    {
        "id": 6404,
        "name_th": "อำเภอกงไกรลาศ",
        "name_en": "Amphoe Kong Krailat",
        "province_id": 64
    },
    {
        "id": 6405,
        "name_th": "อำเภอศรีสัชนาลัย",
        "name_en": "Amphoe Si Satchanalai",
        "province_id": 64
    },
    {
        "id": 6406,
        "name_th": "อำเภอศรีสำโรง",
        "name_en": "Amphoe Si Samrong",
        "province_id": 64
    },
    {
        "id": 6407,
        "name_th": "อำเภอสวรรคโลก",
        "name_en": "Amphoe Sawankhalok",
        "province_id": 64
    },
    {
        "id": 6408,
        "name_th": "อำเภอศรีนคร",
        "name_en": "Amphoe Si Nakhon",
        "province_id": 64
    },
    {
        "id": 6409,
        "name_th": "อำเภอทุ่งเสลี่ยม",
        "name_en": "Amphoe Thung Saliam",
        "province_id": 64
    },
    {
        "id": 6501,
        "name_th": "อำเภอเมืองพิษณุโลก",
        "name_en": "Amphoe Mueang Phitsanulok",
        "province_id": 65
    },
    {
        "id": 6502,
        "name_th": "อำเภอนครไทย",
        "name_en": "Amphoe Nakhon Thai",
        "province_id": 65
    },
    {
        "id": 6503,
        "name_th": "อำเภอชาติตระการ",
        "name_en": "Amphoe Chat Trakan",
        "province_id": 65
    },
    {
        "id": 6504,
        "name_th": "อำเภอบางระกำ",
        "name_en": "Amphoe Bang Rakam",
        "province_id": 65
    },
    {
        "id": 6505,
        "name_th": "อำเภอบางกระทุ่ม",
        "name_en": "Amphoe Bang Krathum",
        "province_id": 65
    },
    {
        "id": 6506,
        "name_th": "อำเภอพรหมพิราม",
        "name_en": "Amphoe Phrom Phiram",
        "province_id": 65
    },
    {
        "id": 6507,
        "name_th": "อำเภอวัดโบสถ์",
        "name_en": "Amphoe Wat Bot",
        "province_id": 65
    },
    {
        "id": 6508,
        "name_th": "อำเภอวังทอง",
        "name_en": "Amphoe Wang Thong",
        "province_id": 65
    },
    {
        "id": 6509,
        "name_th": "อำเภอเนินมะปราง",
        "name_en": "Amphoe Noen Maprang",
        "province_id": 65
    },
    {
        "id": 6601,
        "name_th": "อำเภอเมืองพิจิตร",
        "name_en": "Amphoe Mueang Phichit",
        "province_id": 66
    },
    {
        "id": 6602,
        "name_th": "อำเภอวังทรายพูน",
        "name_en": "Amphoe Wang Sai Phun",
        "province_id": 66
    },
    {
        "id": 6603,
        "name_th": "อำเภอโพธิ์ประทับช้าง",
        "name_en": "Amphoe Pho Prathap Chang",
        "province_id": 66
    },
    {
        "id": 6604,
        "name_th": "อำเภอตะพานหิน",
        "name_en": "Amphoe Taphan Hin",
        "province_id": 66
    },
    {
        "id": 6605,
        "name_th": "อำเภอบางมูลนาก",
        "name_en": "Amphoe Bang Mun Nak",
        "province_id": 66
    },
    {
        "id": 6606,
        "name_th": "อำเภอโพทะเล",
        "name_en": "Amphoe Pho Thale",
        "province_id": 66
    },
    {
        "id": 6607,
        "name_th": "อำเภอสามง่าม",
        "name_en": "Amphoe Sam Ngam",
        "province_id": 66
    },
    {
        "id": 6608,
        "name_th": "อำเภอทับคล้อ",
        "name_en": "Amphoe Thap Khlo",
        "province_id": 66
    },
    {
        "id": 6609,
        "name_th": "อำเภอสากเหล็ก",
        "name_en": "Amphoe Sak Lek",
        "province_id": 66
    },
    {
        "id": 6610,
        "name_th": "อำเภอบึงนาราง",
        "name_en": "Amphoe Bueng Na Rang",
        "province_id": 66
    },
    {
        "id": 6611,
        "name_th": "อำเภอดงเจริญ",
        "name_en": "Amphoe Dong Charoen",
        "province_id": 66
    },
    {
        "id": 6612,
        "name_th": "อำเภอวชิรบารมี",
        "name_en": "Amphoe Wachirabarami",
        "province_id": 66
    },
    {
        "id": 6701,
        "name_th": "อำเภอเมืองเพชรบูรณ์",
        "name_en": "Amphoe Mueang Phetchabun",
        "province_id": 67
    },
    {
        "id": 6702,
        "name_th": "อำเภอชนแดน",
        "name_en": "Amphoe Chon Daen",
        "province_id": 67
    },
    {
        "id": 6703,
        "name_th": "อำเภอหล่มสัก",
        "name_en": "Amphoe Lom Sak",
        "province_id": 67
    },
    {
        "id": 6704,
        "name_th": "อำเภอหล่มเก่า",
        "name_en": "Amphoe Lom Kao",
        "province_id": 67
    },
    {
        "id": 6705,
        "name_th": "อำเภอวิเชียรบุรี",
        "name_en": "Amphoe Wichian Buri",
        "province_id": 67
    },
    {
        "id": 6706,
        "name_th": "อำเภอศรีเทพ",
        "name_en": "Amphoe Si Thep",
        "province_id": 67
    },
    {
        "id": 6707,
        "name_th": "อำเภอหนองไผ่",
        "name_en": "Amphoe Nong Phai",
        "province_id": 67
    },
    {
        "id": 6708,
        "name_th": "อำเภอบึงสามพัน",
        "name_en": "Amphoe Bueng Sam Phan",
        "province_id": 67
    },
    {
        "id": 6709,
        "name_th": "อำเภอน้ำหนาว",
        "name_en": "Amphoe Nam Nao",
        "province_id": 67
    },
    {
        "id": 6710,
        "name_th": "อำเภอวังโป่ง",
        "name_en": "Amphoe Wang Pong",
        "province_id": 67
    },
    {
        "id": 6711,
        "name_th": "อำเภอเขาค้อ",
        "name_en": "Amphoe Khao Kho",
        "province_id": 67
    },
    {
        "id": 7001,
        "name_th": "อำเภอเมืองราชบุรี",
        "name_en": "Amphoe Mueang Ratchaburi",
        "province_id": 70
    },
    {
        "id": 7002,
        "name_th": "อำเภอจอมบึง",
        "name_en": "Amphoe Chom Bueng",
        "province_id": 70
    },
    {
        "id": 7003,
        "name_th": "อำเภอสวนผึ้ง",
        "name_en": "Amphoe Suan Phueng",
        "province_id": 70
    },
    {
        "id": 7004,
        "name_th": "อำเภอดำเนินสะดวก",
        "name_en": "Amphoe Damnoen Saduak",
        "province_id": 70
    },
    {
        "id": 7005,
        "name_th": "อำเภอบ้านโป่ง",
        "name_en": "Amphoe Ban Pong",
        "province_id": 70
    },
    {
        "id": 7006,
        "name_th": "อำเภอบางแพ",
        "name_en": "Amphoe Bang Phae",
        "province_id": 70
    },
    {
        "id": 7007,
        "name_th": "อำเภอโพธาราม",
        "name_en": "Amphoe Photharam",
        "province_id": 70
    },
    {
        "id": 7008,
        "name_th": "อำเภอปากท่อ",
        "name_en": "Amphoe Pak Tho",
        "province_id": 70
    },
    {
        "id": 7009,
        "name_th": "อำเภอวัดเพลง",
        "name_en": "Amphoe Wat Phleng",
        "province_id": 70
    },
    {
        "id": 7010,
        "name_th": "อำเภอบ้านคา",
        "name_en": "Amphoe Ban Kha",
        "province_id": 70
    },
    {
        "id": 7101,
        "name_th": "อำเภอเมืองกาญจนบุรี",
        "name_en": "Amphoe Mueang Kanchanaburi",
        "province_id": 71
    },
    {
        "id": 7102,
        "name_th": "อำเภอไทรโยค",
        "name_en": "Amphoe Sai Yok",
        "province_id": 71
    },
    {
        "id": 7103,
        "name_th": "อำเภอบ่อพลอย",
        "name_en": "Amphoe Bo Phloi",
        "province_id": 71
    },
    {
        "id": 7104,
        "name_th": "อำเภอศรีสวัสดิ์",
        "name_en": "Amphoe Si Sawat",
        "province_id": 71
    },
    {
        "id": 7105,
        "name_th": "อำเภอท่ามะกา",
        "name_en": "Amphoe Tha Maka",
        "province_id": 71
    },
    {
        "id": 7106,
        "name_th": "อำเภอท่าม่วง",
        "name_en": "Amphoe Tha Muang",
        "province_id": 71
    },
    {
        "id": 7107,
        "name_th": "อำเภอทองผาภูมิ",
        "name_en": "Amphoe Thong Pha Phum",
        "province_id": 71
    },
    {
        "id": 7108,
        "name_th": "อำเภอสังขละบุรี",
        "name_en": "Amphoe Sangkhla Buri",
        "province_id": 71
    },
    {
        "id": 7109,
        "name_th": "อำเภอพนมทวน",
        "name_en": "Amphoe Phanom Thuan",
        "province_id": 71
    },
    {
        "id": 7110,
        "name_th": "อำเภอเลาขวัญ",
        "name_en": "Amphoe Lao Khwan",
        "province_id": 71
    },
    {
        "id": 7111,
        "name_th": "อำเภอด่านมะขามเตี้ย",
        "name_en": "Amphoe Dan Makham Tia",
        "province_id": 71
    },
    {
        "id": 7112,
        "name_th": "อำเภอหนองปรือ",
        "name_en": "Amphoe Nong Prue",
        "province_id": 71
    },
    {
        "id": 7113,
        "name_th": "อำเภอห้วยกระเจา",
        "name_en": "Amphoe Huai Krachao",
        "province_id": 71
    },
    {
        "id": 7201,
        "name_th": "อำเภอเมืองสุพรรณบุรี",
        "name_en": "Amphoe Mueang Suphan Buri",
        "province_id": 72
    },
    {
        "id": 7202,
        "name_th": "อำเภอเดิมบางนางบวช",
        "name_en": "Amphoe Doem Bang Nang Buat",
        "province_id": 72
    },
    {
        "id": 7203,
        "name_th": "อำเภอด่านช้าง",
        "name_en": "Amphoe Dan Chang",
        "province_id": 72
    },
    {
        "id": 7204,
        "name_th": "อำเภอบางปลาม้า",
        "name_en": "Amphoe Bang Pla Ma",
        "province_id": 72
    },
    {
        "id": 7205,
        "name_th": "อำเภอศรีประจันต์",
        "name_en": "Amphoe Si Prachan",
        "province_id": 72
    },
    {
        "id": 7206,
        "name_th": "อำเภอดอนเจดีย์",
        "name_en": "Amphoe Don Chedi",
        "province_id": 72
    },
    {
        "id": 7207,
        "name_th": "อำเภอสองพี่น้อง",
        "name_en": "Amphoe Song Phi Nong",
        "province_id": 72
    },
    {
        "id": 7208,
        "name_th": "อำเภอสามชุก",
        "name_en": "Amphoe Sam Chuk",
        "province_id": 72
    },
    {
        "id": 7209,
        "name_th": "อำเภออู่ทอง",
        "name_en": "Amphoe U Thong",
        "province_id": 72
    },
    {
        "id": 7210,
        "name_th": "อำเภอหนองหญ้าไซ",
        "name_en": "Amphoe Nong Ya Sai",
        "province_id": 72
    },
    {
        "id": 7301,
        "name_th": "อำเภอเมืองนครปฐม",
        "name_en": "Amphoe Mueang Nakhon Pathom",
        "province_id": 73
    },
    {
        "id": 7302,
        "name_th": "อำเภอกำแพงแสน",
        "name_en": "Amphoe Kamphaeng Saen",
        "province_id": 73
    },
    {
        "id": 7303,
        "name_th": "อำเภอนครชัยศรี",
        "name_en": "Amphoe Nakhon Chai Si",
        "province_id": 73
    },
    {
        "id": 7304,
        "name_th": "อำเภอดอนตูม",
        "name_en": "Amphoe Don Tum",
        "province_id": 73
    },
    {
        "id": 7305,
        "name_th": "อำเภอบางเลน",
        "name_en": "Amphoe Bang Len",
        "province_id": 73
    },
    {
        "id": 7306,
        "name_th": "อำเภอสามพราน",
        "name_en": "Amphoe Sam Phran",
        "province_id": 73
    },
    {
        "id": 7307,
        "name_th": "อำเภอพุทธมณฑล",
        "name_en": "Amphoe Phutthamonthon",
        "province_id": 73
    },
    {
        "id": 7401,
        "name_th": "อำเภอเมืองสมุทรสาคร",
        "name_en": "Amphoe Mueang Samut Sakhon",
        "province_id": 74
    },
    {
        "id": 7402,
        "name_th": "อำเภอกระทุ่มแบน",
        "name_en": "Amphoe Krathum Baen",
        "province_id": 74
    },
    {
        "id": 7403,
        "name_th": "อำเภอบ้านแพ้ว",
        "name_en": "Amphoe Ban Phaeo",
        "province_id": 74
    },
    {
        "id": 7501,
        "name_th": "อำเภอเมืองสมุทรสงคราม",
        "name_en": "Amphoe Mueang Samut Songkhram",
        "province_id": 75
    },
    {
        "id": 7502,
        "name_th": "อำเภอบางคนที",
        "name_en": "Amphoe Bang Khonthi",
        "province_id": 75
    },
    {
        "id": 7503,
        "name_th": "อำเภออัมพวา",
        "name_en": "Amphoe Amphawa",
        "province_id": 75
    },
    {
        "id": 7601,
        "name_th": "อำเภอเมืองเพชรบุรี",
        "name_en": "Amphoe Mueang Phetchaburi",
        "province_id": 76
    },
    {
        "id": 7602,
        "name_th": "อำเภอเขาย้อย",
        "name_en": "Amphoe Khao Yoi",
        "province_id": 76
    },
    {
        "id": 7603,
        "name_th": "อำเภอหนองหญ้าปล้อง",
        "name_en": "Amphoe Nong Ya Plong",
        "province_id": 76
    },
    {
        "id": 7604,
        "name_th": "อำเภอชะอำ",
        "name_en": "Amphoe Cha-am",
        "province_id": 76
    },
    {
        "id": 7605,
        "name_th": "อำเภอท่ายาง",
        "name_en": "Amphoe Tha Yang",
        "province_id": 76
    },
    {
        "id": 7606,
        "name_th": "อำเภอบ้านลาด",
        "name_en": "Amphoe Ban Lat",
        "province_id": 76
    },
    {
        "id": 7607,
        "name_th": "อำเภอบ้านแหลม",
        "name_en": "Amphoe Ban Laem",
        "province_id": 76
    },
    {
        "id": 7608,
        "name_th": "อำเภอแก่งกระจาน",
        "name_en": "Amphoe Kaeng Krachan",
        "province_id": 76
    },
    {
        "id": 7701,
        "name_th": "อำเภอเมืองประจวบคีรีขันธ์",
        "name_en": "Amphoe Mueang Prachuap Khiri Khan",
        "province_id": 77
    },
    {
        "id": 7702,
        "name_th": "อำเภอกุยบุรี",
        "name_en": "Amphoe Kui Buri",
        "province_id": 77
    },
    {
        "id": 7703,
        "name_th": "อำเภอทับสะแก",
        "name_en": "Amphoe Thap Sakae",
        "province_id": 77
    },
    {
        "id": 7704,
        "name_th": "อำเภอบางสะพาน",
        "name_en": "Amphoe Bang Saphan",
        "province_id": 77
    },
    {
        "id": 7705,
        "name_th": "อำเภอบางสะพานน้อย",
        "name_en": "Amphoe Bang Saphan Noi",
        "province_id": 77
    },
    {
        "id": 7706,
        "name_th": "อำเภอปราณบุรี",
        "name_en": "Amphoe Pran Buri",
        "province_id": 77
    },
    {
        "id": 7707,
        "name_th": "อำเภอหัวหิน",
        "name_en": "Amphoe Hua Hin",
        "province_id": 77
    },
    {
        "id": 7708,
        "name_th": "อำเภอสามร้อยยอด",
        "name_en": "Amphoe Sam Roi Yot",
        "province_id": 77
    },
    {
        "id": 8001,
        "name_th": "อำเภอเมืองนครศรีธรรมราช",
        "name_en": "Amphoe Mueang Nakhon Si Thammarat",
        "province_id": 80
    },
    {
        "id": 8002,
        "name_th": "อำเภอพรหมคีรี",
        "name_en": "Amphoe Phrom Khiri",
        "province_id": 80
    },
    {
        "id": 8003,
        "name_th": "อำเภอลานสกา",
        "name_en": "Amphoe Lan Saka",
        "province_id": 80
    },
    {
        "id": 8004,
        "name_th": "อำเภอฉวาง",
        "name_en": "Amphoe Chawang",
        "province_id": 80
    },
    {
        "id": 8005,
        "name_th": "อำเภอพิปูน",
        "name_en": "Amphoe Phipun",
        "province_id": 80
    },
    {
        "id": 8006,
        "name_th": "อำเภอเชียรใหญ่",
        "name_en": "Amphoe Chian Yai",
        "province_id": 80
    },
    {
        "id": 8007,
        "name_th": "อำเภอชะอวด",
        "name_en": "Amphoe Cha-uat",
        "province_id": 80
    },
    {
        "id": 8008,
        "name_th": "อำเภอท่าศาลา",
        "name_en": "Amphoe Tha Sala",
        "province_id": 80
    },
    {
        "id": 8009,
        "name_th": "อำเภอทุ่งสง",
        "name_en": "Amphoe Thung Song",
        "province_id": 80
    },
    {
        "id": 8010,
        "name_th": "อำเภอนาบอน",
        "name_en": "Amphoe Na Bon",
        "province_id": 80
    },
    {
        "id": 8011,
        "name_th": "อำเภอทุ่งใหญ่",
        "name_en": "Amphoe Thung Yai",
        "province_id": 80
    },
    {
        "id": 8012,
        "name_th": "อำเภอปากพนัง",
        "name_en": "Amphoe Pak Phanang",
        "province_id": 80
    },
    {
        "id": 8013,
        "name_th": "อำเภอร่อนพิบูลย์",
        "name_en": "Amphoe Ron Phibun",
        "province_id": 80
    },
    {
        "id": 8014,
        "name_th": "อำเภอสิชล",
        "name_en": "Amphoe Sichon",
        "province_id": 80
    },
    {
        "id": 8015,
        "name_th": "อำเภอขนอม",
        "name_en": "Amphoe Khanom",
        "province_id": 80
    },
    {
        "id": 8016,
        "name_th": "อำเภอหัวไทร",
        "name_en": "Amphoe Hua Sai",
        "province_id": 80
    },
    {
        "id": 8017,
        "name_th": "อำเภอบางขัน",
        "name_en": "Amphoe Bang Khan",
        "province_id": 80
    },
    {
        "id": 8018,
        "name_th": "อำเภอถ้ำพรรณรา",
        "name_en": "Amphoe Tham Phannara",
        "province_id": 80
    },
    {
        "id": 8019,
        "name_th": "อำเภอจุฬาภรณ์",
        "name_en": "Amphoe Chulabhorn",
        "province_id": 80
    },
    {
        "id": 8020,
        "name_th": "อำเภอพระพรหม",
        "name_en": "Amphoe Phra Phrom",
        "province_id": 80
    },
    {
        "id": 8021,
        "name_th": "อำเภอนบพิตำ",
        "name_en": "Amphoe Nopphitam",
        "province_id": 80
    },
    {
        "id": 8022,
        "name_th": "อำเภอช้างกลาง",
        "name_en": "Amphoe Chang Klang",
        "province_id": 80
    },
    {
        "id": 8023,
        "name_th": "อำเภอเฉลิมพระเกียรติ",
        "name_en": "Amphoe Chaloem Phra Kiat",
        "province_id": 80
    },
    {
        "id": 8101,
        "name_th": "อำเภอเมืองกระบี่",
        "name_en": "Amphoe Mueang Krabi",
        "province_id": 81
    },
    {
        "id": 8102,
        "name_th": "อำเภอเขาพนม",
        "name_en": "Amphoe Khao Phanom",
        "province_id": 81
    },
    {
        "id": 8103,
        "name_th": "อำเภอเกาะลันตา",
        "name_en": "Amphoe Ko Lanta",
        "province_id": 81
    },
    {
        "id": 8104,
        "name_th": "อำเภอคลองท่อม",
        "name_en": "Amphoe Khlong Thom",
        "province_id": 81
    },
    {
        "id": 8105,
        "name_th": "อำเภออ่าวลึก",
        "name_en": "Amphoe Ao Luek",
        "province_id": 81
    },
    {
        "id": 8106,
        "name_th": "อำเภอปลายพระยา",
        "name_en": "Amphoe Plai Phraya",
        "province_id": 81
    },
    {
        "id": 8107,
        "name_th": "อำเภอลำทับ",
        "name_en": "Amphoe Lam Thap",
        "province_id": 81
    },
    {
        "id": 8108,
        "name_th": "อำเภอเหนือคลอง",
        "name_en": "Amphoe Nuea Khlong",
        "province_id": 81
    },
    {
        "id": 8201,
        "name_th": "อำเภอเมืองพังงา",
        "name_en": "Amphoe Mueang Phang-nga",
        "province_id": 82
    },
    {
        "id": 8202,
        "name_th": "อำเภอเกาะยาว",
        "name_en": "Amphoe Ko Yao",
        "province_id": 82
    },
    {
        "id": 8203,
        "name_th": "อำเภอกะปง",
        "name_en": "Amphoe Kapong",
        "province_id": 82
    },
    {
        "id": 8204,
        "name_th": "อำเภอตะกั่วทุ่ง",
        "name_en": "Amphoe Takua Thung",
        "province_id": 82
    },
    {
        "id": 8205,
        "name_th": "อำเภอตะกั่วป่า",
        "name_en": "Amphoe Takua Pa",
        "province_id": 82
    },
    {
        "id": 8206,
        "name_th": "อำเภอคุระบุรี",
        "name_en": "Amphoe Khura Buri",
        "province_id": 82
    },
    {
        "id": 8207,
        "name_th": "อำเภอทับปุด",
        "name_en": "Amphoe Thap Put",
        "province_id": 82
    },
    {
        "id": 8208,
        "name_th": "อำเภอท้ายเหมือง",
        "name_en": "Amphoe Thai Mueang",
        "province_id": 82
    },
    {
        "id": 8301,
        "name_th": "อำเภอเมืองภูเก็ต",
        "name_en": "Amphoe Mueang Phuket",
        "province_id": 83
    },
    {
        "id": 8302,
        "name_th": "อำเภอกะทู้",
        "name_en": "Amphoe Kathu",
        "province_id": 83
    },
    {
        "id": 8303,
        "name_th": "อำเภอถลาง",
        "name_en": "Amphoe Thalang",
        "province_id": 83
    },
    {
        "id": 8401,
        "name_th": "อำเภอเมืองสุราษฎร์ธานี",
        "name_en": "Amphoe Mueang Surat Thani",
        "province_id": 84
    },
    {
        "id": 8402,
        "name_th": "อำเภอกาญจนดิษฐ์",
        "name_en": "Amphoe Kanchanadit",
        "province_id": 84
    },
    {
        "id": 8403,
        "name_th": "อำเภอดอนสัก",
        "name_en": "Amphoe Don Sak",
        "province_id": 84
    },
    {
        "id": 8404,
        "name_th": "อำเภอเกาะสมุย",
        "name_en": "Amphoe Ko Samui",
        "province_id": 84
    },
    {
        "id": 8405,
        "name_th": "อำเภอเกาะพะงัน",
        "name_en": "Amphoe Ko Pha-ngan",
        "province_id": 84
    },
    {
        "id": 8406,
        "name_th": "อำเภอไชยา",
        "name_en": "Amphoe Chaiya",
        "province_id": 84
    },
    {
        "id": 8407,
        "name_th": "อำเภอท่าชนะ",
        "name_en": "Amphoe Tha Chana",
        "province_id": 84
    },
    {
        "id": 8408,
        "name_th": "อำเภอคีรีรัฐนิคม",
        "name_en": "Amphoe Khiri Rat Nikhom",
        "province_id": 84
    },
    {
        "id": 8409,
        "name_th": "อำเภอบ้านตาขุน",
        "name_en": "Amphoe Ban Ta Khun",
        "province_id": 84
    },
    {
        "id": 8410,
        "name_th": "อำเภอพนม",
        "name_en": "Amphoe Phanom",
        "province_id": 84
    },
    {
        "id": 8411,
        "name_th": "อำเภอท่าฉาง",
        "name_en": "Amphoe Tha Chang",
        "province_id": 84
    },
    {
        "id": 8412,
        "name_th": "อำเภอบ้านนาสาร",
        "name_en": "Amphoe Ban Na San",
        "province_id": 84
    },
    {
        "id": 8413,
        "name_th": "อำเภอบ้านนาเดิม",
        "name_en": "Amphoe Ban Na Doem",
        "province_id": 84
    },
    {
        "id": 8414,
        "name_th": "อำเภอเคียนซา",
        "name_en": "Amphoe Khian Sa",
        "province_id": 84
    },
    {
        "id": 8415,
        "name_th": "อำเภอเวียงสระ",
        "name_en": "Amphoe Wiang Sa",
        "province_id": 84
    },
    {
        "id": 8416,
        "name_th": "อำเภอพระแสง",
        "name_en": "Amphoe Phrasaeng",
        "province_id": 84
    },
    {
        "id": 8417,
        "name_th": "อำเภอพุนพิน",
        "name_en": "Amphoe Phunphin",
        "province_id": 84
    },
    {
        "id": 8418,
        "name_th": "อำเภอชัยบุรี",
        "name_en": "Amphoe Chai Buri",
        "province_id": 84
    },
    {
        "id": 8419,
        "name_th": "อำเภอวิภาวดี",
        "name_en": "Amphoe Vibhavadi",
        "province_id": 84
    },
    {
        "id": 8501,
        "name_th": "อำเภอเมืองระนอง",
        "name_en": "Amphoe Mueang Ranong",
        "province_id": 85
    },
    {
        "id": 8502,
        "name_th": "อำเภอละอุ่น",
        "name_en": "Amphoe La-un",
        "province_id": 85
    },
    {
        "id": 8503,
        "name_th": "อำเภอกะเปอร์",
        "name_en": "Amphoe Kapoe",
        "province_id": 85
    },
    {
        "id": 8504,
        "name_th": "อำเภอกระบุรี",
        "name_en": "Amphoe Kra Buri",
        "province_id": 85
    },
    {
        "id": 8505,
        "name_th": "อำเภอสุขสำราญ",
        "name_en": "Amphoe Suk Samran",
        "province_id": 85
    },
    {
        "id": 8601,
        "name_th": "อำเภอเมืองชุมพร",
        "name_en": "Amphoe Mueang Chumphon",
        "province_id": 86
    },
    {
        "id": 8602,
        "name_th": "อำเภอท่าแซะ",
        "name_en": "Amphoe Tha Sae",
        "province_id": 86
    },
    {
        "id": 8603,
        "name_th": "อำเภอปะทิว",
        "name_en": "Amphoe Pathio",
        "province_id": 86
    },
    {
        "id": 8604,
        "name_th": "อำเภอหลังสวน",
        "name_en": "Amphoe Lang Suan",
        "province_id": 86
    },
    {
        "id": 8605,
        "name_th": "อำเภอละแม",
        "name_en": "Amphoe Lamae",
        "province_id": 86
    },
    {
        "id": 8606,
        "name_th": "อำเภอพะโต๊ะ",
        "name_en": "Amphoe Phato",
        "province_id": 86
    },
    {
        "id": 8607,
        "name_th": "อำเภอสวี",
        "name_en": "Amphoe Sawi",
        "province_id": 86
    },
    {
        "id": 8608,
        "name_th": "อำเภอทุ่งตะโก",
        "name_en": "Amphoe Thung Tako",
        "province_id": 86
    },
    {
        "id": 9001,
        "name_th": "อำเภอเมืองสงขลา",
        "name_en": "Amphoe Mueang Songkhla",
        "province_id": 90
    },
    {
        "id": 9002,
        "name_th": "อำเภอสทิงพระ",
        "name_en": "Amphoe Sathing Phra",
        "province_id": 90
    },
    {
        "id": 9003,
        "name_th": "อำเภอจะนะ",
        "name_en": "Amphoe Chana",
        "province_id": 90
    },
    {
        "id": 9004,
        "name_th": "อำเภอนาทวี",
        "name_en": "Amphoe Na Thawi",
        "province_id": 90
    },
    {
        "id": 9005,
        "name_th": "อำเภอเทพา",
        "name_en": "Amphoe Thepha",
        "province_id": 90
    },
    {
        "id": 9006,
        "name_th": "อำเภอสะบ้าย้อย",
        "name_en": "Amphoe Saba Yoi",
        "province_id": 90
    },
    {
        "id": 9007,
        "name_th": "อำเภอระโนด",
        "name_en": "Amphoe Ranot",
        "province_id": 90
    },
    {
        "id": 9008,
        "name_th": "อำเภอกระแสสินธุ์",
        "name_en": "Amphoe Krasae Sin",
        "province_id": 90
    },
    {
        "id": 9009,
        "name_th": "อำเภอรัตภูมิ",
        "name_en": "Amphoe Rattaphum",
        "province_id": 90
    },
    {
        "id": 9010,
        "name_th": "อำเภอสะเดา",
        "name_en": "Amphoe Sadao",
        "province_id": 90
    },
    {
        "id": 9011,
        "name_th": "อำเภอหาดใหญ่",
        "name_en": "Amphoe Hat Yai",
        "province_id": 90
    },
    {
        "id": 9012,
        "name_th": "อำเภอนาหม่อม",
        "name_en": "Amphoe Na Mom",
        "province_id": 90
    },
    {
        "id": 9013,
        "name_th": "อำเภอควนเนียง",
        "name_en": "Amphoe Khuan Niang",
        "province_id": 90
    },
    {
        "id": 9014,
        "name_th": "อำเภอบางกล่ำ",
        "name_en": "Amphoe Bang Klam",
        "province_id": 90
    },
    {
        "id": 9015,
        "name_th": "อำเภอสิงหนคร",
        "name_en": "Amphoe Singhanakhon",
        "province_id": 90
    },
    {
        "id": 9016,
        "name_th": "อำเภอคลองหอยโข่ง",
        "name_en": "Amphoe Khlong Hoi Khong",
        "province_id": 90
    },
    {
        "id": 9101,
        "name_th": "อำเภอเมืองสตูล",
        "name_en": "Amphoe Mueang Satun",
        "province_id": 91
    },
    {
        "id": 9102,
        "name_th": "อำเภอควนโดน",
        "name_en": "Amphoe Khuan Don",
        "province_id": 91
    },
    {
        "id": 9103,
        "name_th": "อำเภอควนกาหลง",
        "name_en": "Amphoe Khuan Kalong",
        "province_id": 91
    },
    {
        "id": 9104,
        "name_th": "อำเภอท่าแพ",
        "name_en": "Amphoe Tha Phae",
        "province_id": 91
    },
    {
        "id": 9105,
        "name_th": "อำเภอละงู",
        "name_en": "Amphoe La-ngu",
        "province_id": 91
    },
    {
        "id": 9106,
        "name_th": "อำเภอทุ่งหว้า",
        "name_en": "Amphoe Thung Wa",
        "province_id": 91
    },
    {
        "id": 9107,
        "name_th": "อำเภอมะนัง",
        "name_en": "Amphoe Manang",
        "province_id": 91
    },
    {
        "id": 9201,
        "name_th": "อำเภอเมืองตรัง",
        "name_en": "Amphoe Mueang Trang",
        "province_id": 92
    },
    {
        "id": 9202,
        "name_th": "อำเภอกันตัง",
        "name_en": "Amphoe Kantang",
        "province_id": 92
    },
    {
        "id": 9203,
        "name_th": "อำเภอย่านตาขาว",
        "name_en": "Amphoe Yan Ta Khao",
        "province_id": 92
    },
    {
        "id": 9204,
        "name_th": "อำเภอปะเหลียน",
        "name_en": "Amphoe Palian",
        "province_id": 92
    },
    {
        "id": 9205,
        "name_th": "อำเภอสิเกา",
        "name_en": "Amphoe Sikao",
        "province_id": 92
    },
    {
        "id": 9206,
        "name_th": "อำเภอห้วยยอด",
        "name_en": "Amphoe Huai Yot",
        "province_id": 92
    },
    {
        "id": 9207,
        "name_th": "อำเภอวังวิเศษ",
        "name_en": "Amphoe Wang Wiset",
        "province_id": 92
    },
    {
        "id": 9208,
        "name_th": "อำเภอนาโยง",
        "name_en": "Amphoe Na Yong",
        "province_id": 92
    },
    {
        "id": 9209,
        "name_th": "อำเภอรัษฎา",
        "name_en": "Amphoe Ratsada",
        "province_id": 92
    },
    {
        "id": 9210,
        "name_th": "อำเภอหาดสำราญ",
        "name_en": "Amphoe Hat Samran",
        "province_id": 92
    },
    {
        "id": 9301,
        "name_th": "อำเภอเมืองพัทลุง",
        "name_en": "Amphoe Mueang Phatthalung",
        "province_id": 93
    },
    {
        "id": 9302,
        "name_th": "อำเภอกงหรา",
        "name_en": "Amphoe Kong Ra",
        "province_id": 93
    },
    {
        "id": 9303,
        "name_th": "อำเภอเขาชัยสน",
        "name_en": "Amphoe Khao Chaison",
        "province_id": 93
    },
    {
        "id": 9304,
        "name_th": "อำเภอตะโหมด",
        "name_en": "Amphoe Tamot",
        "province_id": 93
    },
    {
        "id": 9305,
        "name_th": "อำเภอควนขนุน",
        "name_en": "Amphoe Khuan Khanun",
        "province_id": 93
    },
    {
        "id": 9306,
        "name_th": "อำเภอปากพะยูน",
        "name_en": "Amphoe Pak Phayun",
        "province_id": 93
    },
    {
        "id": 9307,
        "name_th": "อำเภอศรีบรรพต",
        "name_en": "Amphoe Si Banphot",
        "province_id": 93
    },
    {
        "id": 9308,
        "name_th": "อำเภอป่าบอน",
        "name_en": "Amphoe Pa Bon",
        "province_id": 93
    },
    {
        "id": 9309,
        "name_th": "อำเภอบางแก้ว",
        "name_en": "Amphoe Bang Kaeo",
        "province_id": 93
    },
    {
        "id": 9310,
        "name_th": "อำเภอป่าพะยอม",
        "name_en": "Amphoe Pa Phayom",
        "province_id": 93
    },
    {
        "id": 9311,
        "name_th": "อำเภอศรีนครินทร์",
        "name_en": "Amphoe Srinagarindra",
        "province_id": 93
    },
    {
        "id": 9401,
        "name_th": "อำเภอเมืองปัตตานี",
        "name_en": "Amphoe Mueang Pattani",
        "province_id": 94
    },
    {
        "id": 9402,
        "name_th": "อำเภอโคกโพธิ์",
        "name_en": "Amphoe Khok Pho",
        "province_id": 94
    },
    {
        "id": 9403,
        "name_th": "อำเภอหนองจิก",
        "name_en": "Amphoe Nong Chik",
        "province_id": 94
    },
    {
        "id": 9404,
        "name_th": "อำเภอปะนาเระ",
        "name_en": "Amphoe Panare",
        "province_id": 94
    },
    {
        "id": 9405,
        "name_th": "อำเภอมายอ",
        "name_en": "Amphoe Mayo",
        "province_id": 94
    },
    {
        "id": 9406,
        "name_th": "อำเภอทุ่งยางแดง",
        "name_en": "Amphoe Thung Yang Daeng",
        "province_id": 94
    },
    {
        "id": 9407,
        "name_th": "อำเภอสายบุรี",
        "name_en": "Amphoe Sai Buri",
        "province_id": 94
    },
    {
        "id": 9408,
        "name_th": "อำเภอไม้แก่น",
        "name_en": "Amphoe Mai Kaen",
        "province_id": 94
    },
    {
        "id": 9409,
        "name_th": "อำเภอยะหริ่ง",
        "name_en": "Amphoe Yaring",
        "province_id": 94
    },
    {
        "id": 9410,
        "name_th": "อำเภอยะรัง",
        "name_en": "Amphoe Yarang",
        "province_id": 94
    },
    {
        "id": 9411,
        "name_th": "อำเภอกะพ้อ",
        "name_en": "Amphoe Kapho",
        "province_id": 94
    },
    {
        "id": 9412,
        "name_th": "อำเภอแม่ลาน",
        "name_en": "Amphoe Mae Lan",
        "province_id": 94
    },
    {
        "id": 9501,
        "name_th": "อำเภอเมืองยะลา",
        "name_en": "Amphoe Mueang Yala",
        "province_id": 95
    },
    {
        "id": 9502,
        "name_th": "อำเภอเบตง",
        "name_en": "Amphoe Betong",
        "province_id": 95
    },
    {
        "id": 9503,
        "name_th": "อำเภอบันนังสตา",
        "name_en": "Amphoe Bannang Sata",
        "province_id": 95
    },
    {
        "id": 9504,
        "name_th": "อำเภอธารโต",
        "name_en": "Amphoe Than To",
        "province_id": 95
    },
    {
        "id": 9505,
        "name_th": "อำเภอยะหา",
        "name_en": "Amphoe Yaha",
        "province_id": 95
    },
    {
        "id": 9506,
        "name_th": "อำเภอรามัน",
        "name_en": "Amphoe Raman",
        "province_id": 95
    },
    {
        "id": 9507,
        "name_th": "อำเภอกาบัง",
        "name_en": "Amphoe Kabang",
        "province_id": 95
    },
    {
        "id": 9508,
        "name_th": "อำเภอกรงปินัง",
        "name_en": "Amphoe Krong Pinang",
        "province_id": 95
    },
    {
        "id": 9601,
        "name_th": "อำเภอเมืองนราธิวาส",
        "name_en": "Amphoe Mueang Narathiwat",
        "province_id": 96
    },
    {
        "id": 9602,
        "name_th": "อำเภอตากใบ",
        "name_en": "Amphoe Tak Bai",
        "province_id": 96
    },
    {
        "id": 9603,
        "name_th": "อำเภอบาเจาะ",
        "name_en": "Amphoe Bacho",
        "province_id": 96
    },
    {
        "id": 9604,
        "name_th": "อำเภอยี่งอ",
        "name_en": "Amphoe Yi-ngo",
        "province_id": 96
    },
    {
        "id": 9605,
        "name_th": "อำเภอระแงะ",
        "name_en": "Amphoe Ra-ngae",
        "province_id": 96
    },
    {
        "id": 9606,
        "name_th": "อำเภอรือเสาะ",
        "name_en": "Amphoe Rueso",
        "province_id": 96
    },
    {
        "id": 9607,
        "name_th": "อำเภอศรีสาคร",
        "name_en": "Amphoe Si Sakhon",
        "province_id": 96
    },
    {
        "id": 9608,
        "name_th": "อำเภอแว้ง",
        "name_en": "Amphoe Waeng",
        "province_id": 96
    },
    {
        "id": 9609,
        "name_th": "อำเภอสุคิริน",
        "name_en": "Amphoe Sukhirin",
        "province_id": 96
    },
    {
        "id": 9610,
        "name_th": "อำเภอสุไหงโก-ลก",
        "name_en": "Amphoe Su-ngai Kolok",
        "province_id": 96
    },
    {
        "id": 9611,
        "name_th": "อำเภอสุไหงปาดี",
        "name_en": "Amphoe Su-ngai Padi",
        "province_id": 96
    },
    {
        "id": 9612,
        "name_th": "อำเภอจะแนะ",
        "name_en": "Amphoe Chanae",
        "province_id": 96
    },
    {
        "id": 9613,
        "name_th": "อำเภอเจาะไอร้อง",
        "name_en": "Amphoe Cho-airong",
        "province_id": 96
    }
]